(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3558"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3558"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("h3qcY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f5148a61ea716e88$var$App;

var $jURgU = parcelRequire("jURgU");

var $f5148a61ea716e88$var$_Grid = $f5148a61ea716e88$var$_interopRequireDefault((parcelRequire("5QtRe")));

var $f5148a61ea716e88$var$_Modal = $f5148a61ea716e88$var$_interopRequireDefault((parcelRequire("f3F2v")));

var $f5148a61ea716e88$var$_Sidebar = $f5148a61ea716e88$var$_interopRequireDefault((parcelRequire("b6hmR")));

function $f5148a61ea716e88$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $f5148a61ea716e88$var$DebugPanel() {
    const { isDebugEnabled: isDebugEnabled, lastEndpoint: lastEndpoint, maxPages: maxPages, page: page } = (0, $jURgU.useAppContext)();
    if (!isDebugEnabled) return null;
    return /*#__PURE__*/ React.createElement("div", {
        className: "p-3 d-none d-md-block col-12"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "bg-light-subtle px-3 py-2 border rounded-1"
    }, /*#__PURE__*/ React.createElement("h5", null, "DEBUG MODE"), /*#__PURE__*/ React.createElement("p", null, "Last Endpoint: ", lastEndpoint), /*#__PURE__*/ React.createElement("p", null, "Total Pages: ", maxPages), /*#__PURE__*/ React.createElement("p", null, "Current Page: ", page)));
}
function $f5148a61ea716e88$var$Layout() {
    const { toggleMobileFilter: toggleMobileFilter, mobileFilterOpen: mobileFilterOpen, loadMoreRef: loadMoreRef, isBusy: isBusy, onLoadMore: onLoadMore, page: page, maxPages: maxPages } = (0, $jURgU.useAppContext)();
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "container-fluid px-lg-4"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "row"
    }, /*#__PURE__*/ React.createElement($f5148a61ea716e88$var$_Grid.default, null), /*#__PURE__*/ React.createElement("div", {
        className: "col-xl-3 my-4 px-4 px-lg-3 d-xl-block d-none"
    }, /*#__PURE__*/ React.createElement($f5148a61ea716e88$var$_Sidebar.default, null)), page < maxPages && /*#__PURE__*/ React.createElement("div", {
        className: "rl-load-more-wrapper d-flex col-xl-9 col-12 mb-5 flex-column align-items-center"
    }, /*#__PURE__*/ React.createElement("button", {
        ref: loadMoreRef,
        disabled: isBusy,
        type: "button",
        className: "rl-load-more-when-in-vp btn text-secondary text-small fw-bold rounded-pill px-4 py-2 shadow-lg border",
        onClick: onLoadMore
    }, isBusy ? "Loading..." : "Load More")))), /*#__PURE__*/ React.createElement("div", {
        className: "d-flex d-xl-none d-flex align-items-center justify-content-center position-fixed w-100",
        style: {
            bottom: "3em",
            zIndex: "102"
        }
    }, /*#__PURE__*/ React.createElement("button", {
        type: "button",
        className: "btn btn-primary rounded-pill px-4 text-uppercase",
        onClick: toggleMobileFilter
    }, "Filter")), /*#__PURE__*/ React.createElement($f5148a61ea716e88$var$_Modal.default, {
        onClose: (e)=>{
            e.preventDefault();
            toggleMobileFilter();
        },
        isModalOpen: mobileFilterOpen,
        className: "border-1 border-light-subtle p-0 rounded relative",
        style: {
            maxHeight: "65dvh",
            overscrollBehavior: "contain"
        }
    }, /*#__PURE__*/ React.createElement($f5148a61ea716e88$var$_Sidebar.default, {
        className: "h-100 py-3 px-4 w-100"
    })));
}
function $f5148a61ea716e88$var$App() {
    return /*#__PURE__*/ React.createElement($jURgU.AppProvider, null, /*#__PURE__*/ React.createElement($f5148a61ea716e88$var$DebugPanel, null), /*#__PURE__*/ React.createElement($f5148a61ea716e88$var$Layout, null));
}

});
parcelRegister("jURgU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AppProvider = $688cd8f260df66df$var$AppProvider;
module.exports.default = void 0;
module.exports.useAppContext = $688cd8f260df66df$var$useAppContext;

var $688cd8f260df66df$var$_apiFetch = $688cd8f260df66df$var$_interopRequireDefault((parcelRequire("3TSey")));
function $688cd8f260df66df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const { createContext: $688cd8f260df66df$var$createContext, useContext: $688cd8f260df66df$var$useContext, useState: $688cd8f260df66df$var$useState, useMemo: $688cd8f260df66df$var$useMemo, useCallback: $688cd8f260df66df$var$useCallback, useRef: $688cd8f260df66df$var$useRef } = window.React;
const $688cd8f260df66df$var$AppContext = $688cd8f260df66df$var$createContext({
    postsPromise: Promise.resolve([]),
    postsRef: null,
    categoriesFiltered: [],
    resourceTypesFiltered: [],
    handleToggle: ()=>{},
    resetFilters: ()=>{},
    page: 1,
    maxPages: 0,
    isBusy: true,
    onLoadMore: ()=>{},
    loadMoreRef: ()=>{},
    mobileFilterOpen: false,
    toggleMobileFilter: ()=>{},
    isDebugEnabled: false,
    lastEndpoint: ""
});
function $688cd8f260df66df$var$useAppContext() {
    const context = $688cd8f260df66df$var$useContext($688cd8f260df66df$var$AppContext);
    if (!context) throw new Error("useAppContext must be used within AppProvider");
    return context;
}
const $688cd8f260df66df$var$loadMoreObserver = new IntersectionObserver((entries)=>{
    entries.forEach(({ target: target, isIntersecting: isIntersecting })=>isIntersecting && target.click());
}, {
    root: null,
    rootMargin: "720px",
    threshold: [
        0
    ]
});
function $688cd8f260df66df$var$AppProvider({ children: children }) {
    const isDebugEnabled = $688cd8f260df66df$var$useMemo(()=>new URL(window.location.href).searchParams.has("debug") && window.adw?.is_user_logged_in, []);
    const postsRef = $688cd8f260df66df$var$useRef([]);
    const [{ page: page, maxPages: maxPages, isBusy: isBusy, mobileFilterOpen: mobileFilterOpen, categoriesFiltered: categoriesFiltered, resourceTypesFiltered: resourceTypesFiltered, lastEndpoint: lastEndpoint }, setState] = $688cd8f260df66df$var$useState({
        page: 1,
        maxPages: 0,
        isBusy: true,
        mobileFilterOpen: false,
        categoriesFiltered: [],
        resourceTypesFiltered: [],
        lastEndpoint: ""
    });
    const loadMoreRef = $688cd8f260df66df$var$useCallback((btnNode)=>{
        if (btnNode) {
            $688cd8f260df66df$var$loadMoreObserver.observe(btnNode);
            return;
        }
        $688cd8f260df66df$var$loadMoreObserver?.disconnect();
    }, []);
    const onLoadMore = $688cd8f260df66df$var$useCallback(()=>{
        if (isBusy) return;
        setState((prev)=>{
            if (prev.page + 1 <= prev.maxPages) return {
                ...prev,
                page: prev.page + 1,
                isBusy: true
            };
            return prev;
        });
    }, [
        isBusy
    ]);
    const handleToggle = $688cd8f260df66df$var$useCallback(({ id: id, taxonomy: taxonomy })=>{
        postsRef.current = [];
        setState((prev)=>{
            const key = taxonomy === "category" ? "categoriesFiltered" : "resourceTypesFiltered";
            const current = prev[key];
            const updated = current.includes(id) ? current.filter((filterId)=>filterId !== id) : current.concat(id);
            prev.page = 1;
            prev.isBusy = true;
            prev[key] = updated;
            return structuredClone(prev);
        });
    }, []);
    const resetFilters = $688cd8f260df66df$var$useCallback(()=>{
        postsRef.current = [];
        setState((prev)=>({
                ...prev,
                page: 1,
                maxPages: 0,
                isBusy: true,
                categoriesFiltered: [],
                resourceTypesFiltered: []
            }));
    }, []);
    const toggleMobileFilter = $688cd8f260df66df$var$useCallback((open)=>{
        setState((prev)=>({
                ...prev,
                mobileFilterOpen: typeof open === "boolean" ? open : !prev.mobileFilterOpen
            }));
    }, []);
    const postsPromise = $688cd8f260df66df$var$useMemo(async ()=>{
        const urlEndpoint = new URL(window.location.origin + `/wp-json/adw-resource-hub/v1/posts`);
        urlEndpoint.searchParams.set("page", page);
        urlEndpoint.searchParams.set("categories", categoriesFiltered);
        urlEndpoint.searchParams.set("resource_types", resourceTypesFiltered);
        if (isDebugEnabled) setState((prev)=>({
                ...prev,
                lastEndpoint: urlEndpoint.toString()
            }));
        return (0, $688cd8f260df66df$var$_apiFetch.default)({
            path: urlEndpoint.toString(),
            method: "GET"
        }).then(({ posts: newPosts = [], max_num_pages: max_num_pages = 1 })=>{
            postsRef.current = postsRef.current.concat(newPosts);
            setState((prev)=>({
                    ...prev,
                    maxPages: max_num_pages ?? 1,
                    isBusy: false
                }));
            return postsRef.current;
        }).catch((err)=>{
            console.error("Error fetching resource hub posts:", err);
            setState((prev)=>({
                    ...prev,
                    isBusy: false
                }));
            postsRef.current = [];
            return postsRef.current;
        });
    }, [
        page,
        categoriesFiltered,
        resourceTypesFiltered,
        isDebugEnabled
    ]);
    const value = $688cd8f260df66df$var$useMemo(()=>({
            postsPromise: postsPromise,
            postsRef: postsRef,
            categoriesFiltered: // Filters
            categoriesFiltered,
            resourceTypesFiltered: resourceTypesFiltered,
            handleToggle: handleToggle,
            resetFilters: resetFilters,
            page: // Pagination
            page,
            maxPages: maxPages,
            isBusy: isBusy,
            onLoadMore: onLoadMore,
            loadMoreRef: loadMoreRef,
            mobileFilterOpen: // Mobile
            mobileFilterOpen,
            toggleMobileFilter: toggleMobileFilter,
            isDebugEnabled: // Debug
            isDebugEnabled,
            lastEndpoint: lastEndpoint
        }), [
        postsRef,
        postsPromise,
        categoriesFiltered,
        resourceTypesFiltered,
        handleToggle,
        resetFilters,
        page,
        maxPages,
        isBusy,
        onLoadMore,
        loadMoreRef,
        mobileFilterOpen,
        toggleMobileFilter,
        isDebugEnabled,
        lastEndpoint
    ]);
    return /*#__PURE__*/ React.createElement($688cd8f260df66df$var$AppContext.Provider, {
        value: value
    }, children);
}
var $688cd8f260df66df$var$_default = module.exports.default = $688cd8f260df66df$var$AppContext;

});
parcelRegister("3TSey", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $2d7093daa3cfeafb$export$2e2bcd8739ae039; });

var $lB7P9 = parcelRequire("lB7P9");

var $4nNod = parcelRequire("4nNod");
parcelRequire("5hZ7V");
var $lw5wl = parcelRequire("lw5wl");

var $bzJpk = parcelRequire("bzJpk");

var $jeRRq = parcelRequire("jeRRq");

var $4pPMs = parcelRequire("4pPMs");

var $9tXdA = parcelRequire("9tXdA");

var $kA638 = parcelRequire("kA638");

var $7uiCi = parcelRequire("7uiCi");

var $lfMVe = parcelRequire("lfMVe");

var $88Zkf = parcelRequire("88Zkf");

var $5XIr7 = parcelRequire("5XIr7");
function $2d7093daa3cfeafb$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2d7093daa3cfeafb$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $2d7093daa3cfeafb$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $lB7P9.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $2d7093daa3cfeafb$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * Default set of header values which should be sent with every request unless
 * explicitly provided through apiFetch options.
 *
 * @type {Record<string, string>}
 */ var $2d7093daa3cfeafb$var$DEFAULT_HEADERS = {
    // The backend uses the Accept header as a condition for considering an
    // incoming request as a REST request.
    //
    // See: https://core.trac.wordpress.org/ticket/44534
    Accept: 'application/json, */*;q=0.1'
};
/**
 * Default set of fetch option values which should be sent with every request
 * unless explicitly provided through apiFetch options.
 *
 * @type {Object}
 */ var $2d7093daa3cfeafb$var$DEFAULT_OPTIONS = {
    credentials: 'include'
};
/** @typedef {import('./types').APIFetchMiddleware} APIFetchMiddleware */ /** @typedef {import('./types').APIFetchOptions} APIFetchOptions */ /**
 * @type {import('./types').APIFetchMiddleware[]}
 */ var $2d7093daa3cfeafb$var$middlewares = [
    (0, $lfMVe.default),
    (0, $kA638.default),
    (0, $7uiCi.default),
    (0, $9tXdA.default)
];
/**
 * Register a middleware
 *
 * @param {import('./types').APIFetchMiddleware} middleware
 */ function $2d7093daa3cfeafb$var$registerMiddleware(middleware) {
    $2d7093daa3cfeafb$var$middlewares.unshift(middleware);
}
/**
 * Checks the status of a response, throwing the Response as an error if
 * it is outside the 200 range.
 *
 * @param {Response} response
 * @return {Response} The response if the status is in the 200 range.
 */ var $2d7093daa3cfeafb$var$checkStatus = function checkStatus(response) {
    if (response.status >= 200 && response.status < 300) return response;
    throw response;
};
/** @typedef {(options: import('./types').APIFetchOptions) => Promise<any>} FetchHandler*/ /**
 * @type {FetchHandler}
 */ var $2d7093daa3cfeafb$var$defaultFetchHandler = function defaultFetchHandler(nextOptions) {
    var url = nextOptions.url, path = nextOptions.path, data = nextOptions.data, _nextOptions$parse = nextOptions.parse, parse = _nextOptions$parse === void 0 ? true : _nextOptions$parse, remainingOptions = (0, $4nNod.default)(nextOptions, [
        "url",
        "path",
        "data",
        "parse"
    ]);
    var body = nextOptions.body, headers = nextOptions.headers; // Merge explicitly-provided headers with default values.
    headers = $2d7093daa3cfeafb$var$_objectSpread($2d7093daa3cfeafb$var$_objectSpread({}, $2d7093daa3cfeafb$var$DEFAULT_HEADERS), headers); // The `data` property is a shorthand for sending a JSON body.
    if (data) {
        body = JSON.stringify(data);
        headers['Content-Type'] = 'application/json';
    }
    var responsePromise = window.fetch(url || path || window.location.href, $2d7093daa3cfeafb$var$_objectSpread($2d7093daa3cfeafb$var$_objectSpread($2d7093daa3cfeafb$var$_objectSpread({}, $2d7093daa3cfeafb$var$DEFAULT_OPTIONS), remainingOptions), {}, {
        body: body,
        headers: headers
    }));
    return responsePromise // Return early if fetch errors. If fetch error, there is most likely no
    // network connection. Unfortunately fetch just throws a TypeError and
    // the message might depend on the browser.
    .then(function(value) {
        return Promise.resolve(value).then($2d7093daa3cfeafb$var$checkStatus).catch(function(response) {
            return (0, $5XIr7.parseAndThrowError)(response, parse);
        }).then(function(response) {
            return (0, $5XIr7.parseResponseAndNormalizeError)(response, parse);
        });
    }, function() {
        throw {
            code: 'fetch_error',
            message: (0, $lw5wl.__)('You are probably offline.')
        };
    });
};
/** @type {FetchHandler} */ var $2d7093daa3cfeafb$var$fetchHandler = $2d7093daa3cfeafb$var$defaultFetchHandler;
/**
 * Defines a custom fetch handler for making the requests that will override
 * the default one using window.fetch
 *
 * @param {FetchHandler} newFetchHandler The new fetch handler
 */ function $2d7093daa3cfeafb$var$setFetchHandler(newFetchHandler) {
    $2d7093daa3cfeafb$var$fetchHandler = newFetchHandler;
}
/**
 * @template T
 * @param {import('./types').APIFetchOptions} options
 * @return {Promise<T>} A promise representing the request processed via the registered middlewares.
 */ function $2d7093daa3cfeafb$var$apiFetch(options) {
    // creates a nested function chain that calls all middlewares and finally the `fetchHandler`,
    // converting `middlewares = [ m1, m2, m3 ]` into:
    // ```
    // opts1 => m1( opts1, opts2 => m2( opts2, opts3 => m3( opts3, fetchHandler ) ) );
    // ```
    var enhancedHandler = $2d7093daa3cfeafb$var$middlewares.reduceRight(function(/** @type {FetchHandler} */ next, middleware) {
        return function(workingOptions) {
            return middleware(workingOptions, next);
        };
    }, $2d7093daa3cfeafb$var$fetchHandler);
    return enhancedHandler(options).catch(function(error) {
        if (error.code !== 'rest_cookie_invalid_nonce') return Promise.reject(error);
         // If the nonce is invalid, refresh it and try again.
        return window // @ts-ignore
        .fetch($2d7093daa3cfeafb$var$apiFetch.nonceEndpoint).then($2d7093daa3cfeafb$var$checkStatus).then(function(data) {
            return data.text();
        }).then(function(text) {
            // @ts-ignore
            $2d7093daa3cfeafb$var$apiFetch.nonceMiddleware.nonce = text;
            return $2d7093daa3cfeafb$var$apiFetch(options);
        });
    });
}
$2d7093daa3cfeafb$var$apiFetch.use = $2d7093daa3cfeafb$var$registerMiddleware;
$2d7093daa3cfeafb$var$apiFetch.setFetchHandler = $2d7093daa3cfeafb$var$setFetchHandler;
$2d7093daa3cfeafb$var$apiFetch.createNonceMiddleware = (0, $bzJpk.default);
$2d7093daa3cfeafb$var$apiFetch.createPreloadingMiddleware = (0, $4pPMs.default);
$2d7093daa3cfeafb$var$apiFetch.createRootURLMiddleware = (0, $jeRRq.default);
$2d7093daa3cfeafb$var$apiFetch.fetchAllMiddleware = (0, $9tXdA.default);
$2d7093daa3cfeafb$var$apiFetch.mediaUploadMiddleware = (0, $88Zkf.default);
var $2d7093daa3cfeafb$export$2e2bcd8739ae039 = $2d7093daa3cfeafb$var$apiFetch;

});
parcelRegister("lB7P9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb931f60d8d226d8$export$2e2bcd8739ae039; });

var $d9KNw = parcelRequire("d9KNw");
function $fb931f60d8d226d8$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $d9KNw.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("d9KNw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99406aaafdabc25e$export$2e2bcd8739ae039; });

var $ana82 = parcelRequire("ana82");

var $g7Qem = parcelRequire("g7Qem");
function $99406aaafdabc25e$export$2e2bcd8739ae039(t) {
    var i = (0, $g7Qem.default)(t, "string");
    return "symbol" == (0, $ana82.default)(i) ? i : i + "";
}

});
parcelRegister("ana82", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78d3e8b7d5e47526$export$2e2bcd8739ae039; });
function $78d3e8b7d5e47526$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $78d3e8b7d5e47526$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $78d3e8b7d5e47526$export$2e2bcd8739ae039(o);
}

});

parcelRegister("g7Qem", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bbd5d0b4a89d436f$export$2e2bcd8739ae039; });

var $ana82 = parcelRequire("ana82");
function $bbd5d0b4a89d436f$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $ana82.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $ana82.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("4nNod", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $330f9f25da865537$export$2e2bcd8739ae039; });

var $3L80X = parcelRequire("3L80X");
function $330f9f25da865537$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $3L80X.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("3L80X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2bcbfa5ccfc3d1d2$export$2e2bcd8739ae039; });
function $2bcbfa5ccfc3d1d2$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("5hZ7V", function(module, exports) {

$parcel$export(module.exports, "__", function () { return (parcelRequire("lw5wl")).__; });

var $jFUBA = parcelRequire("jFUBA");
parcelRequire("7rJ4Q");

var $lw5wl = parcelRequire("lw5wl");

});
parcelRegister("jFUBA", function(module, exports) {
/**
 * External dependencies
 */ 
var $dovcy = parcelRequire("dovcy");

var $ktvUs = parcelRequire("ktvUs");
/**
 * Log to console, once per message; or more precisely, per referentially equal
 * argument set. Because Jed throws errors, we log these to the console instead
 * to avoid crashing the application.
 *
 * @param {...*} args Arguments to pass to `console.error`
 */ var $e52dc14b4acfa0f4$var$logErrorOnce = (0, (/*@__PURE__*/$parcel$interopDefault($dovcy)))(console.error); // eslint-disable-line no-console
function $e52dc14b4acfa0f4$export$63151d8bb18a49f9(format) {
    try {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return (0, (/*@__PURE__*/$parcel$interopDefault($ktvUs))).sprintf.apply((0, (/*@__PURE__*/$parcel$interopDefault($ktvUs))), [
            format
        ].concat(args));
    } catch (error) {
        $e52dc14b4acfa0f4$var$logErrorOnce('sprintf error: \n\n' + error.toString());
        return format;
    }
}

});
parcelRegister("dovcy", function(module, exports) {
/**
 * Memize options object.
 *
 * @typedef MemizeOptions
 *
 * @property {number} [maxSize] Maximum size of the cache.
 */ /**
 * Internal cache entry.
 *
 * @typedef MemizeCacheNode
 *
 * @property {?MemizeCacheNode|undefined} [prev] Previous node.
 * @property {?MemizeCacheNode|undefined} [next] Next node.
 * @property {Array<*>}                   args   Function arguments for cache
 *                                               entry.
 * @property {*}                          val    Function result.
 */ /**
 * Properties of the enhanced function for controlling cache.
 *
 * @typedef MemizeMemoizedFunction
 *
 * @property {()=>void} clear Clear the cache.
 */ /**
 * Accepts a function to be memoized, and returns a new memoized function, with
 * optional options.
 *
 * @template {Function} F
 *
 * @param {F}             fn        Function to memoize.
 * @param {MemizeOptions} [options] Options object.
 *
 * @return {F & MemizeMemoizedFunction} Memoized function.
 */ function $9c05b8394461a218$var$memize(fn, options) {
    var size = 0;
    /** @type {?MemizeCacheNode|undefined} */ var head;
    /** @type {?MemizeCacheNode|undefined} */ var tail;
    options = options || {};
    function memoized() {
        var node = head, len = arguments.length, args, i;
        searchCache: while(node){
            // Perform a shallow equality test to confirm that whether the node
            // under test is a candidate for the arguments passed. Two arrays
            // are shallowly equal if their length matches and each entry is
            // strictly equal between the two sets. Avoid abstracting to a
            // function which could incur an arguments leaking deoptimization.
            // Check whether node arguments match arguments length
            if (node.args.length !== arguments.length) {
                node = node.next;
                continue;
            }
            // Check whether node arguments match arguments values
            for(i = 0; i < len; i++)if (node.args[i] !== arguments[i]) {
                node = node.next;
                continue searchCache;
            }
            // At this point we can assume we've found a match
            // Surface matched node to head if not already
            if (node !== head) {
                // As tail, shift to previous. Must only shift if not also
                // head, since if both head and tail, there is no previous.
                if (node === tail) tail = node.prev;
                // Adjust siblings to point to each other. If node was tail,
                // this also handles new tail's empty `next` assignment.
                /** @type {MemizeCacheNode} */ node.prev.next = node.next;
                if (node.next) node.next.prev = node.prev;
                node.next = head;
                node.prev = null;
                /** @type {MemizeCacheNode} */ head.prev = node;
                head = node;
            }
            // Return immediately
            return node.val;
        }
        // No cached value found. Continue to insertion phase:
        // Create a copy of arguments (avoid leaking deoptimization)
        args = new Array(len);
        for(i = 0; i < len; i++)args[i] = arguments[i];
        node = {
            args: args,
            // Generate the result from original function
            val: fn.apply(null, args)
        };
        // Don't need to check whether node is already head, since it would
        // have been returned above already if it was
        // Shift existing head down list
        if (head) {
            head.prev = node;
            node.next = head;
        } else // If no head, follows that there's no tail (at initial or reset)
        tail = node;
        // Trim tail if we're reached max size and are pending cache insertion
        if (size === /** @type {MemizeOptions} */ options.maxSize) {
            tail = /** @type {MemizeCacheNode} */ tail.prev;
            /** @type {MemizeCacheNode} */ tail.next = null;
        } else size++;
        head = node;
        return node.val;
    }
    memoized.clear = function() {
        head = null;
        tail = null;
        size = 0;
    };
    // Ignore reason: There's not a clear solution to create an intersection of
    // the function with additional properties, where the goal is to retain the
    // function signature of the incoming argument and add control properties
    // on the return value.
    // @ts-ignore
    return memoized;
}
module.exports = $9c05b8394461a218$var$memize;

});

parcelRegister("ktvUs", function(module, exports) {

$parcel$export(module.exports, "sprintf", function () { return $ee7f44ac105f5f3a$export$63151d8bb18a49f9; }, function (v) { return $ee7f44ac105f5f3a$export$63151d8bb18a49f9 = v; });
$parcel$export(module.exports, "vsprintf", function () { return $ee7f44ac105f5f3a$export$790fb69b1a2884f9; }, function (v) { return $ee7f44ac105f5f3a$export$790fb69b1a2884f9 = v; });
/* global window, exports, define */ var $ee7f44ac105f5f3a$export$63151d8bb18a49f9;
var $ee7f44ac105f5f3a$export$790fb69b1a2884f9;
!function() {
    'use strict';
    var re = {
        not_string: /[^s]/,
        not_bool: /[^t]/,
        not_type: /[^T]/,
        not_primitive: /[^v]/,
        number: /[diefg]/,
        numeric_arg: /[bcdiefguxX]/,
        json: /[j]/,
        not_json: /[^j]/,
        text: /^[^\x25]+/,
        modulo: /^\x25{2}/,
        placeholder: /^\x25(?:([1-9]\d*)\$|\(([^)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/,
        key: /^([a-z_][a-z_\d]*)/i,
        key_access: /^\.([a-z_][a-z_\d]*)/i,
        index_access: /^\[(\d+)\]/,
        sign: /^[+-]/
    };
    function sprintf(key) {
        // `arguments` is not an array, but should be fine for this call
        return sprintf_format(sprintf_parse(key), arguments);
    }
    function vsprintf(fmt, argv) {
        return sprintf.apply(null, [
            fmt
        ].concat(argv || []));
    }
    function sprintf_format(parse_tree, argv) {
        var cursor = 1, tree_length = parse_tree.length, arg, output = '', i, k, ph, pad, pad_character, pad_length, is_positive, sign;
        for(i = 0; i < tree_length; i++){
            if (typeof parse_tree[i] === 'string') output += parse_tree[i];
            else if (typeof parse_tree[i] === 'object') {
                ph = parse_tree[i] // convenience purposes only
                ;
                if (ph.keys) {
                    arg = argv[cursor];
                    for(k = 0; k < ph.keys.length; k++){
                        if (arg == undefined) throw new Error(sprintf('[sprintf] Cannot access property "%s" of undefined value "%s"', ph.keys[k], ph.keys[k - 1]));
                        arg = arg[ph.keys[k]];
                    }
                } else if (ph.param_no) arg = argv[ph.param_no];
                else arg = argv[cursor++];
                if (re.not_type.test(ph.type) && re.not_primitive.test(ph.type) && arg instanceof Function) arg = arg();
                if (re.numeric_arg.test(ph.type) && typeof arg !== 'number' && isNaN(arg)) throw new TypeError(sprintf('[sprintf] expecting number but found %T', arg));
                if (re.number.test(ph.type)) is_positive = arg >= 0;
                switch(ph.type){
                    case 'b':
                        arg = parseInt(arg, 10).toString(2);
                        break;
                    case 'c':
                        arg = String.fromCharCode(parseInt(arg, 10));
                        break;
                    case 'd':
                    case 'i':
                        arg = parseInt(arg, 10);
                        break;
                    case 'j':
                        arg = JSON.stringify(arg, null, ph.width ? parseInt(ph.width) : 0);
                        break;
                    case 'e':
                        arg = ph.precision ? parseFloat(arg).toExponential(ph.precision) : parseFloat(arg).toExponential();
                        break;
                    case 'f':
                        arg = ph.precision ? parseFloat(arg).toFixed(ph.precision) : parseFloat(arg);
                        break;
                    case 'g':
                        arg = ph.precision ? String(Number(arg.toPrecision(ph.precision))) : parseFloat(arg);
                        break;
                    case 'o':
                        arg = (parseInt(arg, 10) >>> 0).toString(8);
                        break;
                    case 's':
                        arg = String(arg);
                        arg = ph.precision ? arg.substring(0, ph.precision) : arg;
                        break;
                    case 't':
                        arg = String(!!arg);
                        arg = ph.precision ? arg.substring(0, ph.precision) : arg;
                        break;
                    case 'T':
                        arg = Object.prototype.toString.call(arg).slice(8, -1).toLowerCase();
                        arg = ph.precision ? arg.substring(0, ph.precision) : arg;
                        break;
                    case 'u':
                        arg = parseInt(arg, 10) >>> 0;
                        break;
                    case 'v':
                        arg = arg.valueOf();
                        arg = ph.precision ? arg.substring(0, ph.precision) : arg;
                        break;
                    case 'x':
                        arg = (parseInt(arg, 10) >>> 0).toString(16);
                        break;
                    case 'X':
                        arg = (parseInt(arg, 10) >>> 0).toString(16).toUpperCase();
                        break;
                }
                if (re.json.test(ph.type)) output += arg;
                else {
                    if (re.number.test(ph.type) && (!is_positive || ph.sign)) {
                        sign = is_positive ? '+' : '-';
                        arg = arg.toString().replace(re.sign, '');
                    } else sign = '';
                    pad_character = ph.pad_char ? ph.pad_char === '0' ? '0' : ph.pad_char.charAt(1) : ' ';
                    pad_length = ph.width - (sign + arg).length;
                    pad = ph.width ? pad_length > 0 ? pad_character.repeat(pad_length) : '' : '';
                    output += ph.align ? sign + arg + pad : pad_character === '0' ? sign + pad + arg : pad + sign + arg;
                }
            }
        }
        return output;
    }
    var sprintf_cache = Object.create(null);
    function sprintf_parse(fmt) {
        if (sprintf_cache[fmt]) return sprintf_cache[fmt];
        var _fmt = fmt, match, parse_tree = [], arg_names = 0;
        while(_fmt){
            if ((match = re.text.exec(_fmt)) !== null) parse_tree.push(match[0]);
            else if ((match = re.modulo.exec(_fmt)) !== null) parse_tree.push('%');
            else if ((match = re.placeholder.exec(_fmt)) !== null) {
                if (match[2]) {
                    arg_names |= 1;
                    var field_list = [], replacement_field = match[2], field_match = [];
                    if ((field_match = re.key.exec(replacement_field)) !== null) {
                        field_list.push(field_match[1]);
                        while((replacement_field = replacement_field.substring(field_match[0].length)) !== ''){
                            if ((field_match = re.key_access.exec(replacement_field)) !== null) field_list.push(field_match[1]);
                            else if ((field_match = re.index_access.exec(replacement_field)) !== null) field_list.push(field_match[1]);
                            else throw new SyntaxError('[sprintf] failed to parse named argument key');
                        }
                    } else throw new SyntaxError('[sprintf] failed to parse named argument key');
                    match[2] = field_list;
                } else arg_names |= 2;
                if (arg_names === 3) throw new Error('[sprintf] mixing positional and named placeholders is not (yet) supported');
                parse_tree.push({
                    placeholder: match[0],
                    param_no: match[1],
                    keys: match[2],
                    sign: match[3],
                    pad_char: match[4],
                    align: match[5],
                    width: match[6],
                    precision: match[7],
                    type: match[8]
                });
            } else throw new SyntaxError('[sprintf] unexpected placeholder');
            _fmt = _fmt.substring(match[0].length);
        }
        return sprintf_cache[fmt] = parse_tree;
    }
    $ee7f44ac105f5f3a$export$63151d8bb18a49f9 = sprintf;
    $ee7f44ac105f5f3a$export$790fb69b1a2884f9 = vsprintf;
    if (typeof window !== 'undefined') {
        window['sprintf'] = sprintf;
        window['vsprintf'] = vsprintf;
        if (typeof define === 'function' && define['amd']) define(function() {
            return {
                'sprintf': sprintf,
                'vsprintf': vsprintf
            };
        });
    }
/* eslint-enable quote-props */ }(); // eslint-disable-line

});


parcelRegister("7rJ4Q", function(module, exports) {

$parcel$export(module.exports, "createI18n", function () { return $56be05642ebda4a4$export$920091e3d72d80ee; });

var $lB7P9 = parcelRequire("lB7P9");

var $arr15 = parcelRequire("arr15");
function $56be05642ebda4a4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $56be05642ebda4a4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $56be05642ebda4a4$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $lB7P9.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $56be05642ebda4a4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * @typedef {Record<string,any>} LocaleData
 */ /**
 * Default locale data to use for Tannin domain when not otherwise provided.
 * Assumes an English plural forms expression.
 *
 * @type {LocaleData}
 */ var $56be05642ebda4a4$var$DEFAULT_LOCALE_DATA = {
    '': {
        /** @param {number} n */ plural_forms: function plural_forms(n) {
            return n === 1 ? 0 : 1;
        }
    }
};
/*
 * Regular expression that matches i18n hooks like `i18n.gettext`, `i18n.ngettext`,
 * `i18n.gettext_domain` or `i18n.ngettext_with_context` or `i18n.has_translation`.
 */ var $56be05642ebda4a4$var$I18N_HOOK_REGEXP = /^i18n\.(n?gettext|has_translation)(_|$)/;
var $56be05642ebda4a4$export$920091e3d72d80ee = function createI18n(initialData, initialDomain, hooks) {
    /**
   * The underlying instance of Tannin to which exported functions interface.
   *
   * @type {Tannin}
   */ var tannin = new (0, $arr15.default)({});
    var listeners = new Set();
    var notifyListeners = function notifyListeners() {
        listeners.forEach(function(listener) {
            return listener();
        });
    };
    /**
   * Subscribe to changes of locale data.
   *
   * @param {SubscribeCallback} callback Subscription callback.
   * @return {UnsubscribeCallback} Unsubscribe callback.
   */ var subscribe = function subscribe(callback) {
        listeners.add(callback);
        return function() {
            return listeners.delete(callback);
        };
    };
    /** @type {GetLocaleData} */ var getLocaleData = function getLocaleData() {
        var domain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
        return tannin.data[domain];
    };
    /**
   * @param {LocaleData} [data]
   * @param {string} [domain]
   */ var doSetLocaleData = function doSetLocaleData(data) {
        var domain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
        tannin.data[domain] = $56be05642ebda4a4$var$_objectSpread($56be05642ebda4a4$var$_objectSpread($56be05642ebda4a4$var$_objectSpread({}, $56be05642ebda4a4$var$DEFAULT_LOCALE_DATA), tannin.data[domain]), data); // Populate default domain configuration (supported locale date which omits
        // a plural forms expression).
        tannin.data[domain][''] = $56be05642ebda4a4$var$_objectSpread($56be05642ebda4a4$var$_objectSpread({}, $56be05642ebda4a4$var$DEFAULT_LOCALE_DATA['']), tannin.data[domain]['']);
    };
    /** @type {SetLocaleData} */ var setLocaleData = function setLocaleData(data, domain) {
        doSetLocaleData(data, domain);
        notifyListeners();
    };
    /** @type {ResetLocaleData} */ var resetLocaleData = function resetLocaleData(data, domain) {
        // Reset all current Tannin locale data.
        tannin.data = {}; // Reset cached plural forms functions cache.
        tannin.pluralForms = {};
        setLocaleData(data, domain);
    };
    /**
   * Wrapper for Tannin's `dcnpgettext`. Populates default locale data if not
   * otherwise previously assigned.
   *
   * @param {string|undefined} domain   Domain to retrieve the translated text.
   * @param {string|undefined} context  Context information for the translators.
   * @param {string}           single   Text to translate if non-plural. Used as
   *                                    fallback return value on a caught error.
   * @param {string}           [plural] The text to be used if the number is
   *                                    plural.
   * @param {number}           [number] The number to compare against to use
   *                                    either the singular or plural form.
   *
   * @return {string} The translated string.
   */ var dcnpgettext = function dcnpgettext() {
        var domain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
        var context = arguments.length > 1 ? arguments[1] : undefined;
        var single = arguments.length > 2 ? arguments[2] : undefined;
        var plural = arguments.length > 3 ? arguments[3] : undefined;
        var number = arguments.length > 4 ? arguments[4] : undefined;
        if (!tannin.data[domain]) // use `doSetLocaleData` to set silently, without notifying listeners
        doSetLocaleData(undefined, domain);
        return tannin.dcnpgettext(domain, context, single, plural, number);
    };
    /** @type {GetFilterDomain} */ var getFilterDomain = function getFilterDomain() {
        var domain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
        return domain;
    };
    /** @type {__} */ var __ = function __(text, domain) {
        var translation = dcnpgettext(domain, undefined, text);
        if (!hooks) return translation;
        /**
     * Filters text with its translation.
     *
     * @param {string} translation Translated text.
     * @param {string} text        Text to translate.
     * @param {string} domain      Text domain. Unique identifier for retrieving translated strings.
     */ translation = /** @type {string} */ /** @type {*} */ hooks.applyFilters('i18n.gettext', translation, text, domain);
        return /** @type {string} */ /** @type {*} */ hooks.applyFilters('i18n.gettext_' + getFilterDomain(domain), translation, text, domain);
    };
    /** @type {_x} */ var _x = function _x(text, context, domain) {
        var translation = dcnpgettext(domain, context, text);
        if (!hooks) return translation;
        /**
     * Filters text with its translation based on context information.
     *
     * @param {string} translation Translated text.
     * @param {string} text        Text to translate.
     * @param {string} context     Context information for the translators.
     * @param {string} domain      Text domain. Unique identifier for retrieving translated strings.
     */ translation = /** @type {string} */ /** @type {*} */ hooks.applyFilters('i18n.gettext_with_context', translation, text, context, domain);
        return /** @type {string} */ /** @type {*} */ hooks.applyFilters('i18n.gettext_with_context_' + getFilterDomain(domain), translation, text, context, domain);
    };
    /** @type {_n} */ var _n = function _n(single, plural, number, domain) {
        var translation = dcnpgettext(domain, undefined, single, plural, number);
        if (!hooks) return translation;
        /**
     * Filters the singular or plural form of a string.
     *
     * @param {string} translation Translated text.
     * @param {string} single      The text to be used if the number is singular.
     * @param {string} plural      The text to be used if the number is plural.
     * @param {string} number      The number to compare against to use either the singular or plural form.
     * @param {string} domain      Text domain. Unique identifier for retrieving translated strings.
     */ translation = /** @type {string} */ /** @type {*} */ hooks.applyFilters('i18n.ngettext', translation, single, plural, number, domain);
        return /** @type {string} */ /** @type {*} */ hooks.applyFilters('i18n.ngettext_' + getFilterDomain(domain), translation, single, plural, number, domain);
    };
    /** @type {_nx} */ var _nx = function _nx(single, plural, number, context, domain) {
        var translation = dcnpgettext(domain, context, single, plural, number);
        if (!hooks) return translation;
        /**
     * Filters the singular or plural form of a string with gettext context.
     *
     * @param {string} translation Translated text.
     * @param {string} single      The text to be used if the number is singular.
     * @param {string} plural      The text to be used if the number is plural.
     * @param {string} number      The number to compare against to use either the singular or plural form.
     * @param {string} context     Context information for the translators.
     * @param {string} domain      Text domain. Unique identifier for retrieving translated strings.
     */ translation = /** @type {string} */ /** @type {*} */ hooks.applyFilters('i18n.ngettext_with_context', translation, single, plural, number, context, domain);
        return /** @type {string} */ /** @type {*} */ hooks.applyFilters('i18n.ngettext_with_context_' + getFilterDomain(domain), translation, single, plural, number, context, domain);
    };
    /** @type {IsRtl} */ var isRTL = function isRTL() {
        return 'rtl' === _x('ltr', 'text direction');
    };
    /** @type {HasTranslation} */ var hasTranslation = function hasTranslation(single, context, domain) {
        var _tannin$data, _tannin$data2;
        var key = context ? context + "\x04" + single : single;
        var result = !!((_tannin$data = tannin.data) !== null && _tannin$data !== void 0 && (_tannin$data2 = _tannin$data[domain !== null && domain !== void 0 ? domain : 'default']) !== null && _tannin$data2 !== void 0 && _tannin$data2[key]);
        if (hooks) {
            /**
       * Filters the presence of a translation in the locale data.
       *
       * @param {boolean} hasTranslation Whether the translation is present or not..
       * @param {string} single The singular form of the translated text (used as key in locale data)
       * @param {string} context Context information for the translators.
       * @param {string} domain Text domain. Unique identifier for retrieving translated strings.
       */ result = /** @type { boolean } */ /** @type {*} */ hooks.applyFilters('i18n.has_translation', result, single, context, domain);
            result = /** @type { boolean } */ /** @type {*} */ hooks.applyFilters('i18n.has_translation_' + getFilterDomain(domain), result, single, context, domain);
        }
        return result;
    };
    if (initialData) setLocaleData(initialData, initialDomain);
    if (hooks) {
        /**
     * @param {string} hookName
     */ var onHookAddedOrRemoved = function onHookAddedOrRemoved(hookName) {
            if ($56be05642ebda4a4$var$I18N_HOOK_REGEXP.test(hookName)) notifyListeners();
        };
        hooks.addAction('hookAdded', 'core/i18n', onHookAddedOrRemoved);
        hooks.addAction('hookRemoved', 'core/i18n', onHookAddedOrRemoved);
    }
    return {
        getLocaleData: getLocaleData,
        setLocaleData: setLocaleData,
        resetLocaleData: resetLocaleData,
        subscribe: subscribe,
        __: __,
        _x: _x,
        _n: _n,
        _nx: _nx,
        isRTL: isRTL,
        hasTranslation: hasTranslation
    };
};

});
parcelRegister("arr15", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79a161e78d7dd0a5$export$2e2bcd8739ae039; });

var $cSB4o = parcelRequire("cSB4o");
/**
 * Tannin constructor options.
 *
 * @typedef {Object} TanninOptions
 *
 * @property {string}   [contextDelimiter] Joiner in string lookup with context.
 * @property {Function} [onMissingKey]     Callback to invoke when key missing.
 */ /**
 * Domain metadata.
 *
 * @typedef {Object} TanninDomainMetadata
 *
 * @property {string}            [domain]       Domain name.
 * @property {string}            [lang]         Language code.
 * @property {(string|Function)} [plural_forms] Plural forms expression or
 *                                              function evaluator.
 */ /**
 * Domain translation pair respectively representing the singular and plural
 * translation.
 *
 * @typedef {[string,string]} TanninTranslation
 */ /**
 * Locale data domain. The key is used as reference for lookup, the value an
 * array of two string entries respectively representing the singular and plural
 * translation.
 *
 * @typedef {{[key:string]:TanninDomainMetadata|TanninTranslation,'':TanninDomainMetadata|TanninTranslation}} TanninLocaleDomain
 */ /**
 * Jed-formatted locale data.
 *
 * @see http://messageformat.github.io/Jed/
 *
 * @typedef {{[domain:string]:TanninLocaleDomain}} TanninLocaleData
 */ /**
 * Default Tannin constructor options.
 *
 * @type {TanninOptions}
 */ var $79a161e78d7dd0a5$var$DEFAULT_OPTIONS = {
    contextDelimiter: '\u0004',
    onMissingKey: null
};
/**
 * Given a specific locale data's config `plural_forms` value, returns the
 * expression.
 *
 * @example
 *
 * ```
 * getPluralExpression( 'nplurals=2; plural=(n != 1);' ) === '(n != 1)'
 * ```
 *
 * @param {string} pf Locale data plural forms.
 *
 * @return {string} Plural forms expression.
 */ function $79a161e78d7dd0a5$var$getPluralExpression(pf) {
    var parts, i, part;
    parts = pf.split(';');
    for(i = 0; i < parts.length; i++){
        part = parts[i].trim();
        if (part.indexOf('plural=') === 0) return part.substr(7);
    }
}
function $79a161e78d7dd0a5$export$2e2bcd8739ae039(data, options) {
    var key;
    /**
	 * Jed-formatted locale data.
	 *
	 * @name Tannin#data
	 * @type {TanninLocaleData}
	 */ this.data = data;
    /**
	 * Plural forms function cache, keyed by plural forms string.
	 *
	 * @name Tannin#pluralForms
	 * @type {Object<string,Function>}
	 */ this.pluralForms = {};
    /**
	 * Effective options for instance, including defaults.
	 *
	 * @name Tannin#options
	 * @type {TanninOptions}
	 */ this.options = {};
    for(key in $79a161e78d7dd0a5$var$DEFAULT_OPTIONS)this.options[key] = options !== undefined && key in options ? options[key] : $79a161e78d7dd0a5$var$DEFAULT_OPTIONS[key];
}
/**
 * Returns the plural form index for the given domain and value.
 *
 * @param {string} domain Domain on which to calculate plural form.
 * @param {number} n      Value for which plural form is to be calculated.
 *
 * @return {number} Plural form index.
 */ $79a161e78d7dd0a5$export$2e2bcd8739ae039.prototype.getPluralForm = function(domain, n) {
    var getPluralForm = this.pluralForms[domain], config, plural, pf;
    if (!getPluralForm) {
        config = this.data[domain][''];
        pf = config['Plural-Forms'] || config['plural-forms'] || // Ignore reason: As known, there's no way to document the empty
        // string property on a key to guarantee this as metadata.
        // @ts-ignore
        config.plural_forms;
        if (typeof pf !== 'function') {
            plural = $79a161e78d7dd0a5$var$getPluralExpression(config['Plural-Forms'] || config['plural-forms'] || // Ignore reason: As known, there's no way to document the empty
            // string property on a key to guarantee this as metadata.
            // @ts-ignore
            config.plural_forms);
            pf = (0, $cSB4o.default)(plural);
        }
        getPluralForm = this.pluralForms[domain] = pf;
    }
    return getPluralForm(n);
};
/**
 * Translate a string.
 *
 * @param {string}      domain   Translation domain.
 * @param {string|void} context  Context distinguishing terms of the same name.
 * @param {string}      singular Primary key for translation lookup.
 * @param {string=}     plural   Fallback value used for non-zero plural
 *                               form index.
 * @param {number=}     n        Value to use in calculating plural form.
 *
 * @return {string} Translated string.
 */ $79a161e78d7dd0a5$export$2e2bcd8739ae039.prototype.dcnpgettext = function(domain, context, singular, plural, n) {
    var index, key, entry;
    if (n === undefined) // Default to singular.
    index = 0;
    else // Find index by evaluating plural form for value.
    index = this.getPluralForm(domain, n);
    key = singular;
    // If provided, context is prepended to key with delimiter.
    if (context) key = context + this.options.contextDelimiter + singular;
    entry = this.data[domain][key];
    // Verify not only that entry exists, but that the intended index is within
    // range and non-empty.
    if (entry && entry[index]) return entry[index];
    if (this.options.onMissingKey) this.options.onMissingKey(singular, domain);
    // If entry not found, fall back to singular vs. plural with zero index
    // representing the singular value.
    return index === 0 ? singular : plural;
};

});
parcelRegister("cSB4o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9607487fb0d78752$export$2e2bcd8739ae039; });

var $i0Jo2 = parcelRequire("i0Jo2");
function $9607487fb0d78752$export$2e2bcd8739ae039(expression) {
    var evaluate = (0, $i0Jo2.default)(expression);
    return function(n) {
        return +evaluate({
            n: n
        });
    };
}

});
parcelRegister("i0Jo2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1cb6ef432837564$export$2e2bcd8739ae039; });

var $cujAh = parcelRequire("cujAh");

var $1O19P = parcelRequire("1O19P");
function $d1cb6ef432837564$export$2e2bcd8739ae039(expression) {
    var terms = (0, $cujAh.default)(expression);
    return function(variables) {
        return (0, $1O19P.default)(terms, variables);
    };
}

});
parcelRegister("cujAh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91777a68e26585ba$export$2e2bcd8739ae039; });
var $91777a68e26585ba$var$PRECEDENCE, $91777a68e26585ba$var$OPENERS, $91777a68e26585ba$var$TERMINATORS, $91777a68e26585ba$var$PATTERN;
/**
 * Operator precedence mapping.
 *
 * @type {Object}
 */ $91777a68e26585ba$var$PRECEDENCE = {
    '(': 9,
    '!': 8,
    '*': 7,
    '/': 7,
    '%': 7,
    '+': 6,
    '-': 6,
    '<': 5,
    '<=': 5,
    '>': 5,
    '>=': 5,
    '==': 4,
    '!=': 4,
    '&&': 3,
    '||': 2,
    '?': 1,
    '?:': 1
};
/**
 * Characters which signal pair opening, to be terminated by terminators.
 *
 * @type {string[]}
 */ $91777a68e26585ba$var$OPENERS = [
    '(',
    '?'
];
/**
 * Characters which signal pair termination, the value an array with the
 * opener as its first member. The second member is an optional operator
 * replacement to push to the stack.
 *
 * @type {string[]}
 */ $91777a68e26585ba$var$TERMINATORS = {
    ')': [
        '('
    ],
    ':': [
        '?',
        '?:'
    ]
};
/**
 * Pattern matching operators and openers.
 *
 * @type {RegExp}
 */ $91777a68e26585ba$var$PATTERN = /<=|>=|==|!=|&&|\|\||\?:|\(|!|\*|\/|%|\+|-|<|>|\?|\)|:/;
function $91777a68e26585ba$export$2e2bcd8739ae039(expression) {
    var terms = [], stack = [], match, operator, term, element;
    while(match = expression.match($91777a68e26585ba$var$PATTERN)){
        operator = match[0];
        // Term is the string preceding the operator match. It may contain
        // whitespace, and may be empty (if operator is at beginning).
        term = expression.substr(0, match.index).trim();
        if (term) terms.push(term);
        while(element = stack.pop()){
            if ($91777a68e26585ba$var$TERMINATORS[operator]) {
                if ($91777a68e26585ba$var$TERMINATORS[operator][0] === element) {
                    // Substitution works here under assumption that because
                    // the assigned operator will no longer be a terminator, it
                    // will be pushed to the stack during the condition below.
                    operator = $91777a68e26585ba$var$TERMINATORS[operator][1] || operator;
                    break;
                }
            } else if ($91777a68e26585ba$var$OPENERS.indexOf(element) >= 0 || $91777a68e26585ba$var$PRECEDENCE[element] < $91777a68e26585ba$var$PRECEDENCE[operator]) {
                // Push to stack if either an opener or when pop reveals an
                // element of lower precedence.
                stack.push(element);
                break;
            }
            // For each popped from stack, push to terms.
            terms.push(element);
        }
        if (!$91777a68e26585ba$var$TERMINATORS[operator]) stack.push(operator);
        // Slice matched fragment from expression to continue match.
        expression = expression.substr(match.index + operator.length);
    }
    // Push remainder of operand, if exists, to terms.
    expression = expression.trim();
    if (expression) terms.push(expression);
    // Pop remaining items from stack into terms.
    return terms.concat(stack.reverse());
}

});

parcelRegister("1O19P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $150b5bd4cb67b1ad$export$2e2bcd8739ae039; });
/**
 * Operator callback functions.
 *
 * @type {Object}
 */ var $150b5bd4cb67b1ad$var$OPERATORS = {
    '!': function(a) {
        return !a;
    },
    '*': function(a, b) {
        return a * b;
    },
    '/': function(a, b) {
        return a / b;
    },
    '%': function(a, b) {
        return a % b;
    },
    '+': function(a, b) {
        return a + b;
    },
    '-': function(a, b) {
        return a - b;
    },
    '<': function(a, b) {
        return a < b;
    },
    '<=': function(a, b) {
        return a <= b;
    },
    '>': function(a, b) {
        return a > b;
    },
    '>=': function(a, b) {
        return a >= b;
    },
    '==': function(a, b) {
        return a === b;
    },
    '!=': function(a, b) {
        return a !== b;
    },
    '&&': function(a, b) {
        return a && b;
    },
    '||': function(a, b) {
        return a || b;
    },
    '?:': function(a, b, c) {
        if (a) throw b;
        return c;
    }
};
function $150b5bd4cb67b1ad$export$2e2bcd8739ae039(postfix, variables) {
    var stack = [], i, j, args, getOperatorResult, term, value;
    for(i = 0; i < postfix.length; i++){
        term = postfix[i];
        getOperatorResult = $150b5bd4cb67b1ad$var$OPERATORS[term];
        if (getOperatorResult) {
            // Pop from stack by number of function arguments.
            j = getOperatorResult.length;
            args = Array(j);
            while(j--)args[j] = stack.pop();
            try {
                value = getOperatorResult.apply(null, args);
            } catch (earlyReturn) {
                return earlyReturn;
            }
        } else if (variables.hasOwnProperty(term)) value = variables[term];
        else value = +term;
        stack.push(value);
    }
    return stack[0];
}

});





parcelRegister("lw5wl", function(module, exports) {

$parcel$export(module.exports, "__", function () { return $faa0de68c8b23040$export$c6452175cea4361a; });
/**
 * Internal dependencies
 */ 
var $7rJ4Q = parcelRequire("7rJ4Q");

var $dZJJX = parcelRequire("dZJJX");
var $faa0de68c8b23040$var$i18n = (0, $7rJ4Q.createI18n)(undefined, undefined, (0, $dZJJX.defaultHooks));
var /**
 * Default, singleton instance of `I18n`.
 */ $faa0de68c8b23040$export$2e2bcd8739ae039 = $faa0de68c8b23040$var$i18n;
var $faa0de68c8b23040$export$aa5c834303254f2b = $faa0de68c8b23040$var$i18n.getLocaleData.bind($faa0de68c8b23040$var$i18n);
var $faa0de68c8b23040$export$c6dc5f4bd857efee = $faa0de68c8b23040$var$i18n.setLocaleData.bind($faa0de68c8b23040$var$i18n);
var $faa0de68c8b23040$export$455aeb7a226f88e0 = $faa0de68c8b23040$var$i18n.resetLocaleData.bind($faa0de68c8b23040$var$i18n);
var $faa0de68c8b23040$export$ec068583843480e7 = $faa0de68c8b23040$var$i18n.subscribe.bind($faa0de68c8b23040$var$i18n);
var $faa0de68c8b23040$export$c6452175cea4361a = $faa0de68c8b23040$var$i18n.__.bind($faa0de68c8b23040$var$i18n);
var $faa0de68c8b23040$export$2329670d4e6fc0e6 = $faa0de68c8b23040$var$i18n._x.bind($faa0de68c8b23040$var$i18n);
var $faa0de68c8b23040$export$21352aee083e072e = $faa0de68c8b23040$var$i18n._n.bind($faa0de68c8b23040$var$i18n);
var $faa0de68c8b23040$export$63be10810dae5704 = $faa0de68c8b23040$var$i18n._nx.bind($faa0de68c8b23040$var$i18n);
var $faa0de68c8b23040$export$702d680b21cbd764 = $faa0de68c8b23040$var$i18n.isRTL.bind($faa0de68c8b23040$var$i18n);
var $faa0de68c8b23040$export$8a4bbd9646545970 = $faa0de68c8b23040$var$i18n.hasTranslation.bind($faa0de68c8b23040$var$i18n);

});
parcelRegister("dZJJX", function(module, exports) {

$parcel$export(module.exports, "defaultHooks", function () { return $a30473f0f4e255df$export$3ab433d598b5afda; });
/**
 * Internal dependencies
 */ 
var $7ly7s = parcelRequire("7ly7s");
var $a30473f0f4e255df$export$3ab433d598b5afda = (0, $7ly7s.default)();
var $a30473f0f4e255df$export$386cd32f765ce9e5 = $a30473f0f4e255df$export$3ab433d598b5afda.addAction, $a30473f0f4e255df$export$ae939118842f3d6d = $a30473f0f4e255df$export$3ab433d598b5afda.addFilter, $a30473f0f4e255df$export$ee23a0560a6e66e1 = $a30473f0f4e255df$export$3ab433d598b5afda.removeAction, $a30473f0f4e255df$export$3be5fe9f09d6965 = $a30473f0f4e255df$export$3ab433d598b5afda.removeFilter, $a30473f0f4e255df$export$e217e69099d082f5 = $a30473f0f4e255df$export$3ab433d598b5afda.hasAction, $a30473f0f4e255df$export$c529f4fe4b3e42c3 = $a30473f0f4e255df$export$3ab433d598b5afda.hasFilter, $a30473f0f4e255df$export$b6a70a7bac0324dc = $a30473f0f4e255df$export$3ab433d598b5afda.removeAllActions, $a30473f0f4e255df$export$d2b22b11f2d9c961 = $a30473f0f4e255df$export$3ab433d598b5afda.removeAllFilters, $a30473f0f4e255df$export$82b07c9aa09229f9 = $a30473f0f4e255df$export$3ab433d598b5afda.doAction, $a30473f0f4e255df$export$47150c42ed89d097 = $a30473f0f4e255df$export$3ab433d598b5afda.applyFilters, $a30473f0f4e255df$export$48bb562f358e2618 = $a30473f0f4e255df$export$3ab433d598b5afda.currentAction, $a30473f0f4e255df$export$6d4307a0dba6866d = $a30473f0f4e255df$export$3ab433d598b5afda.currentFilter, $a30473f0f4e255df$export$40825d7629aadbf8 = $a30473f0f4e255df$export$3ab433d598b5afda.doingAction, $a30473f0f4e255df$export$79bf63fdc44a5a89 = $a30473f0f4e255df$export$3ab433d598b5afda.doingFilter, $a30473f0f4e255df$export$f75d20bfa140804 = $a30473f0f4e255df$export$3ab433d598b5afda.didAction, $a30473f0f4e255df$export$50fe983f23c864a8 = $a30473f0f4e255df$export$3ab433d598b5afda.didFilter, $a30473f0f4e255df$export$e324594224ef24da = $a30473f0f4e255df$export$3ab433d598b5afda.actions, $a30473f0f4e255df$export$82462a21aead86ed = $a30473f0f4e255df$export$3ab433d598b5afda.filters;

});
parcelRegister("7ly7s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5594f5f2f3b02f25$export$2e2bcd8739ae039; });

var $kd56n = parcelRequire("kd56n");

var $eog4Y = parcelRequire("eog4Y");

var $7WJpW = parcelRequire("7WJpW");

var $iPPzz = parcelRequire("iPPzz");

var $41J9m = parcelRequire("41J9m");

var $9FXR1 = parcelRequire("9FXR1");

var $9318Y = parcelRequire("9318Y");

var $aTd5L = parcelRequire("aTd5L");
var $5594f5f2f3b02f25$export$6ab53e2237e2cbe5 = function _Hooks() {
    (0, $kd56n.default)(this, _Hooks);
    /** @type {import('.').Store} actions */ this.actions = Object.create(null);
    this.actions.__current = [];
    /** @type {import('.').Store} filters */ this.filters = Object.create(null);
    this.filters.__current = [];
    this.addAction = (0, $eog4Y.default)(this, 'actions');
    this.addFilter = (0, $eog4Y.default)(this, 'filters');
    this.removeAction = (0, $7WJpW.default)(this, 'actions');
    this.removeFilter = (0, $7WJpW.default)(this, 'filters');
    this.hasAction = (0, $iPPzz.default)(this, 'actions');
    this.hasFilter = (0, $iPPzz.default)(this, 'filters');
    this.removeAllActions = (0, $7WJpW.default)(this, 'actions', true);
    this.removeAllFilters = (0, $7WJpW.default)(this, 'filters', true);
    this.doAction = (0, $41J9m.default)(this, 'actions');
    this.applyFilters = (0, $41J9m.default)(this, 'filters', true);
    this.currentAction = (0, $9FXR1.default)(this, 'actions');
    this.currentFilter = (0, $9FXR1.default)(this, 'filters');
    this.doingAction = (0, $9318Y.default)(this, 'actions');
    this.doingFilter = (0, $9318Y.default)(this, 'filters');
    this.didAction = (0, $aTd5L.default)(this, 'actions');
    this.didFilter = (0, $aTd5L.default)(this, 'filters');
};
/** @typedef {_Hooks} Hooks */ /**
 * Returns an instance of the hooks object.
 *
 * @return {Hooks} A Hooks instance.
 */ function $5594f5f2f3b02f25$var$createHooks() {
    return new $5594f5f2f3b02f25$export$6ab53e2237e2cbe5();
}
var $5594f5f2f3b02f25$export$2e2bcd8739ae039 = $5594f5f2f3b02f25$var$createHooks;

});
parcelRegister("kd56n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb68faaebde2ec0f$export$2e2bcd8739ae039; });
function $eb68faaebde2ec0f$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("eog4Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a79fc7940346aede$export$2e2bcd8739ae039; });
/**
 * Internal dependencies
 */ 
var $1NzTD = parcelRequire("1NzTD");

var $lptLG = parcelRequire("lptLG");
/**
 * @callback AddHook
 *
 * Adds the hook to the appropriate hooks container.
 *
 * @param {string}               hookName  Name of hook to add
 * @param {string}               namespace The unique namespace identifying the callback in the form `vendor/plugin/function`.
 * @param {import('.').Callback} callback  Function to call when the hook is run
 * @param {number}               [priority=10]  Priority of this hook
 */ /**
 * Returns a function which, when invoked, will add a hook.
 *
 * @param  {import('.').Hooks}    hooks Hooks instance.
 * @param  {import('.').StoreKey} storeKey
 *
 * @return {AddHook} Function that adds a new hook.
 */ function $a79fc7940346aede$var$createAddHook(hooks, storeKey) {
    return function addHook(hookName, namespace, callback) {
        var priority = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 10;
        var hooksStore = hooks[storeKey];
        if (!(0, $lptLG.default)(hookName)) return;
        if (!(0, $1NzTD.default)(namespace)) return;
        if ('function' !== typeof callback) {
            // eslint-disable-next-line no-console
            console.error('The hook callback must be a function.');
            return;
        } // Validate numeric priority
        if ('number' !== typeof priority) {
            // eslint-disable-next-line no-console
            console.error('If specified, the hook priority must be a number.');
            return;
        }
        var handler = {
            callback: callback,
            priority: priority,
            namespace: namespace
        };
        if (hooksStore[hookName]) {
            // Find the correct insert index of the new hook.
            var handlers = hooksStore[hookName].handlers;
            /** @type {number} */ var i;
            for(i = handlers.length; i > 0; i--){
                if (priority >= handlers[i - 1].priority) break;
            }
            if (i === handlers.length) // If append, operate via direct assignment.
            handlers[i] = handler;
            else // Otherwise, insert before index via splice.
            handlers.splice(i, 0, handler);
             // We may also be currently executing this hook.  If the callback
            // we're adding would come after the current callback, there's no
            // problem; otherwise we need to increase the execution index of
            // any other runs by 1 to account for the added element.
            hooksStore.__current.forEach(function(hookInfo) {
                if (hookInfo.name === hookName && hookInfo.currentIndex >= i) hookInfo.currentIndex++;
            });
        } else // This is the first hook of its type.
        hooksStore[hookName] = {
            handlers: [
                handler
            ],
            runs: 0
        };
        if (hookName !== 'hookAdded') hooks.doAction('hookAdded', hookName, namespace, callback, priority);
    };
}
var $a79fc7940346aede$export$2e2bcd8739ae039 = $a79fc7940346aede$var$createAddHook;

});
parcelRegister("1NzTD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14f6364b4569329e$export$2e2bcd8739ae039; });
/**
 * Validate a namespace string.
 *
 * @param  {string} namespace The namespace to validate - should take the form
 *                            `vendor/plugin/function`.
 *
 * @return {boolean}             Whether the namespace is valid.
 */ function $14f6364b4569329e$var$validateNamespace(namespace) {
    if ('string' !== typeof namespace || '' === namespace) {
        // eslint-disable-next-line no-console
        console.error('The namespace must be a non-empty string.');
        return false;
    }
    if (!/^[a-zA-Z][a-zA-Z0-9_.\-\/]*$/.test(namespace)) {
        // eslint-disable-next-line no-console
        console.error('The namespace can only contain numbers, letters, dashes, periods, underscores and slashes.');
        return false;
    }
    return true;
}
var $14f6364b4569329e$export$2e2bcd8739ae039 = $14f6364b4569329e$var$validateNamespace;

});

parcelRegister("lptLG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f963061d2fbba1ad$export$2e2bcd8739ae039; });
/**
 * Validate a hookName string.
 *
 * @param  {string} hookName The hook name to validate. Should be a non empty string containing
 *                           only numbers, letters, dashes, periods and underscores. Also,
 *                           the hook name cannot begin with `__`.
 *
 * @return {boolean}            Whether the hook name is valid.
 */ function $f963061d2fbba1ad$var$validateHookName(hookName) {
    if ('string' !== typeof hookName || '' === hookName) {
        // eslint-disable-next-line no-console
        console.error('The hook name must be a non-empty string.');
        return false;
    }
    if (/^__/.test(hookName)) {
        // eslint-disable-next-line no-console
        console.error('The hook name cannot begin with `__`.');
        return false;
    }
    if (!/^[a-zA-Z][a-zA-Z0-9_.-]*$/.test(hookName)) {
        // eslint-disable-next-line no-console
        console.error('The hook name can only contain numbers, letters, dashes, periods and underscores.');
        return false;
    }
    return true;
}
var $f963061d2fbba1ad$export$2e2bcd8739ae039 = $f963061d2fbba1ad$var$validateHookName;

});


parcelRegister("7WJpW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c912e1fc484d612$export$2e2bcd8739ae039; });
/**
 * Internal dependencies
 */ 
var $1NzTD = parcelRequire("1NzTD");

var $lptLG = parcelRequire("lptLG");
/**
 * @callback RemoveHook
 * Removes the specified callback (or all callbacks) from the hook with a given hookName
 * and namespace.
 *
 * @param {string} hookName  The name of the hook to modify.
 * @param {string} namespace The unique namespace identifying the callback in the
 *                           form `vendor/plugin/function`.
 *
 * @return {number | undefined} The number of callbacks removed.
 */ /**
 * Returns a function which, when invoked, will remove a specified hook or all
 * hooks by the given name.
 *
 * @param  {import('.').Hooks}    hooks Hooks instance.
 * @param  {import('.').StoreKey} storeKey
 * @param  {boolean}              [removeAll=false] Whether to remove all callbacks for a hookName,
 *                                                  without regard to namespace. Used to create
 *                                                  `removeAll*` functions.
 *
 * @return {RemoveHook} Function that removes hooks.
 */ function $5c912e1fc484d612$var$createRemoveHook(hooks, storeKey) {
    var removeAll = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return function removeHook(hookName, namespace) {
        var hooksStore = hooks[storeKey];
        if (!(0, $lptLG.default)(hookName)) return;
        if (!removeAll && !(0, $1NzTD.default)(namespace)) return;
         // Bail if no hooks exist by this name
        if (!hooksStore[hookName]) return 0;
        var handlersRemoved = 0;
        if (removeAll) {
            handlersRemoved = hooksStore[hookName].handlers.length;
            hooksStore[hookName] = {
                runs: hooksStore[hookName].runs,
                handlers: []
            };
        } else {
            // Try to find the specified callback to remove.
            var handlers = hooksStore[hookName].handlers;
            var _loop = function _loop(i) {
                if (handlers[i].namespace === namespace) {
                    handlers.splice(i, 1);
                    handlersRemoved++; // This callback may also be part of a hook that is
                    // currently executing.  If the callback we're removing
                    // comes after the current callback, there's no problem;
                    // otherwise we need to decrease the execution index of any
                    // other runs by 1 to account for the removed element.
                    hooksStore.__current.forEach(function(hookInfo) {
                        if (hookInfo.name === hookName && hookInfo.currentIndex >= i) hookInfo.currentIndex--;
                    });
                }
            };
            for(var i = handlers.length - 1; i >= 0; i--)_loop(i);
        }
        if (hookName !== 'hookRemoved') hooks.doAction('hookRemoved', hookName, namespace);
        return handlersRemoved;
    };
}
var $5c912e1fc484d612$export$2e2bcd8739ae039 = $5c912e1fc484d612$var$createRemoveHook;

});

parcelRegister("iPPzz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db64feaebecbfe2b$export$2e2bcd8739ae039; });
/**
 * @callback HasHook
 *
 * Returns whether any handlers are attached for the given hookName and optional namespace.
 *
 * @param {string} hookName    The name of the hook to check for.
 * @param {string} [namespace] Optional. The unique namespace identifying the callback
 *                             in the form `vendor/plugin/function`.
 *
 * @return {boolean} Whether there are handlers that are attached to the given hook.
 */ /**
 * Returns a function which, when invoked, will return whether any handlers are
 * attached to a particular hook.
 *
 * @param  {import('.').Hooks}    hooks Hooks instance.
 * @param  {import('.').StoreKey} storeKey
 *
 * @return {HasHook} Function that returns whether any handlers are
 *                   attached to a particular hook and optional namespace.
 */ function $db64feaebecbfe2b$var$createHasHook(hooks, storeKey) {
    return function hasHook(hookName, namespace) {
        var hooksStore = hooks[storeKey]; // Use the namespace if provided.
        if ('undefined' !== typeof namespace) return hookName in hooksStore && hooksStore[hookName].handlers.some(function(hook) {
            return hook.namespace === namespace;
        });
        return hookName in hooksStore;
    };
}
var $db64feaebecbfe2b$export$2e2bcd8739ae039 = $db64feaebecbfe2b$var$createHasHook;

});

parcelRegister("41J9m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2eea473e33458fce$export$2e2bcd8739ae039; });
parcelRequire("hSuqf");
/**
 * Returns a function which, when invoked, will execute all callbacks
 * registered to a hook of the specified type, optionally returning the final
 * value of the call chain.
 *
 * @param  {import('.').Hooks}    hooks Hooks instance.
 * @param  {import('.').StoreKey} storeKey
 * @param  {boolean}              [returnFirstArg=false] Whether each hook callback is expected to
 *                                                       return its first argument.
 *
 * @return {(hookName:string, ...args: unknown[]) => unknown} Function that runs hook callbacks.
 */ function $2eea473e33458fce$var$createRunHook(hooks, storeKey) {
    var returnFirstArg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return function runHooks(hookName) {
        var hooksStore = hooks[storeKey];
        if (!hooksStore[hookName]) hooksStore[hookName] = {
            handlers: [],
            runs: 0
        };
        hooksStore[hookName].runs++;
        var handlers = hooksStore[hookName].handlers; // The following code is stripped from production builds.
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (!handlers || !handlers.length) return returnFirstArg ? args[0] : undefined;
        var hookInfo = {
            name: hookName,
            currentIndex: 0
        };
        hooksStore.__current.push(hookInfo);
        while(hookInfo.currentIndex < handlers.length){
            var handler = handlers[hookInfo.currentIndex];
            var result = handler.callback.apply(null, args);
            if (returnFirstArg) args[0] = result;
            hookInfo.currentIndex++;
        }
        hooksStore.__current.pop();
        if (returnFirstArg) return args[0];
    };
}
var $2eea473e33458fce$export$2e2bcd8739ae039 = $2eea473e33458fce$var$createRunHook;

});
parcelRegister("hSuqf", function(module, exports) {

var $uv40s = parcelRequire("uv40s");

var $bdw2e = parcelRequire("bdw2e");

var $45CPT = parcelRequire("45CPT");

var $5XUS7 = parcelRequire("5XUS7");
function $d03f1413c8055345$export$2e2bcd8739ae039(r) {
    return (0, $uv40s.default)(r) || (0, $bdw2e.default)(r) || (0, $45CPT.default)(r) || (0, $5XUS7.default)();
}

});
parcelRegister("uv40s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05bae60b5059fa29$export$2e2bcd8739ae039; });

var $5z2Zn = parcelRequire("5z2Zn");
function $05bae60b5059fa29$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $5z2Zn.default)(r);
}

});
parcelRegister("5z2Zn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40d28a29bc3d0243$export$2e2bcd8739ae039; });
function $40d28a29bc3d0243$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("bdw2e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82a9c213e7b5e835$export$2e2bcd8739ae039; });
function $82a9c213e7b5e835$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("45CPT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2fa5c1109958a2fc$export$2e2bcd8739ae039; });

var $5z2Zn = parcelRequire("5z2Zn");
function $2fa5c1109958a2fc$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $5z2Zn.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $5z2Zn.default)(r, a) : void 0;
    }
}

});

parcelRegister("5XUS7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $457e940208e3f1f6$export$2e2bcd8739ae039; });
function $457e940208e3f1f6$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});



parcelRegister("9FXR1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70b65f2af511ff12$export$2e2bcd8739ae039; });
/**
 * Returns a function which, when invoked, will return the name of the
 * currently running hook, or `null` if no hook of the given type is currently
 * running.
 *
 * @param  {import('.').Hooks}    hooks Hooks instance.
 * @param  {import('.').StoreKey} storeKey
 *
 * @return {() => string | null} Function that returns the current hook name or null.
 */ function $70b65f2af511ff12$var$createCurrentHook(hooks, storeKey) {
    return function currentHook() {
        var _hooksStore$__current, _hooksStore$__current2;
        var hooksStore = hooks[storeKey];
        return (_hooksStore$__current = (_hooksStore$__current2 = hooksStore.__current[hooksStore.__current.length - 1]) === null || _hooksStore$__current2 === void 0 ? void 0 : _hooksStore$__current2.name) !== null && _hooksStore$__current !== void 0 ? _hooksStore$__current : null;
    };
}
var $70b65f2af511ff12$export$2e2bcd8739ae039 = $70b65f2af511ff12$var$createCurrentHook;

});

parcelRegister("9318Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $696547f81e27ac66$export$2e2bcd8739ae039; });
/**
 * @callback DoingHook
 * Returns whether a hook is currently being executed.
 *
 * @param  {string} [hookName] The name of the hook to check for.  If
 *                             omitted, will check for any hook being executed.
 *
 * @return {boolean} Whether the hook is being executed.
 */ /**
 * Returns a function which, when invoked, will return whether a hook is
 * currently being executed.
 *
 * @param  {import('.').Hooks}    hooks Hooks instance.
 * @param  {import('.').StoreKey} storeKey
 *
 * @return {DoingHook} Function that returns whether a hook is currently
 *                     being executed.
 */ function $696547f81e27ac66$var$createDoingHook(hooks, storeKey) {
    return function doingHook(hookName) {
        var hooksStore = hooks[storeKey]; // If the hookName was not passed, check for any current hook.
        if ('undefined' === typeof hookName) return 'undefined' !== typeof hooksStore.__current[0];
         // Return the __current hook.
        return hooksStore.__current[0] ? hookName === hooksStore.__current[0].name : false;
    };
}
var $696547f81e27ac66$export$2e2bcd8739ae039 = $696547f81e27ac66$var$createDoingHook;

});

parcelRegister("aTd5L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ed9323cd336e6f5$export$2e2bcd8739ae039; });
/**
 * Internal dependencies
 */ 
var $lptLG = parcelRequire("lptLG");
/**
 * @callback DidHook
 *
 * Returns the number of times an action has been fired.
 *
 * @param  {string} hookName The hook name to check.
 *
 * @return {number | undefined} The number of times the hook has run.
 */ /**
 * Returns a function which, when invoked, will return the number of times a
 * hook has been called.
 *
 * @param  {import('.').Hooks}    hooks Hooks instance.
 * @param  {import('.').StoreKey} storeKey
 *
 * @return {DidHook} Function that returns a hook's call count.
 */ function $7ed9323cd336e6f5$var$createDidHook(hooks, storeKey) {
    return function didHook(hookName) {
        var hooksStore = hooks[storeKey];
        if (!(0, $lptLG.default)(hookName)) return;
        return hooksStore[hookName] && hooksStore[hookName].runs ? hooksStore[hookName].runs : 0;
    };
}
var $7ed9323cd336e6f5$export$2e2bcd8739ae039 = $7ed9323cd336e6f5$var$createDidHook;

});





parcelRegister("bzJpk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86d62f90d70083c3$export$2e2bcd8739ae039; });

var $lB7P9 = parcelRequire("lB7P9");
function $86d62f90d70083c3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $86d62f90d70083c3$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $86d62f90d70083c3$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $lB7P9.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $86d62f90d70083c3$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * @param {string} nonce
 * @return {import('../types').APIFetchMiddleware & { nonce: string }} A middleware to enhance a request with a nonce.
 */ function $86d62f90d70083c3$var$createNonceMiddleware(nonce) {
    /**
   * @type {import('../types').APIFetchMiddleware & { nonce: string }}
   */ var middleware = function middleware(options, next) {
        var _options$headers = options.headers, headers = _options$headers === void 0 ? {} : _options$headers; // If an 'X-WP-Nonce' header (or any case-insensitive variation
        // thereof) was specified, no need to add a nonce header.
        for(var headerName in headers){
            if (headerName.toLowerCase() === 'x-wp-nonce' && headers[headerName] === middleware.nonce) return next(options);
        }
        return next($86d62f90d70083c3$var$_objectSpread($86d62f90d70083c3$var$_objectSpread({}, options), {}, {
            headers: $86d62f90d70083c3$var$_objectSpread($86d62f90d70083c3$var$_objectSpread({}, headers), {}, {
                'X-WP-Nonce': middleware.nonce
            })
        }));
    };
    middleware.nonce = nonce;
    return middleware;
}
var $86d62f90d70083c3$export$2e2bcd8739ae039 = $86d62f90d70083c3$var$createNonceMiddleware;

});

parcelRegister("jeRRq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0191abbb9f255f1$export$2e2bcd8739ae039; });

var $lB7P9 = parcelRequire("lB7P9");

var $kA638 = parcelRequire("kA638");
function $e0191abbb9f255f1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e0191abbb9f255f1$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $e0191abbb9f255f1$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $lB7P9.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $e0191abbb9f255f1$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * @param {string} rootURL
 * @return {import('../types').APIFetchMiddleware} Root URL middleware.
 */ var $e0191abbb9f255f1$var$createRootURLMiddleware = function createRootURLMiddleware(rootURL) {
    return function(options, next) {
        return (0, $kA638.default)(options, function(optionsWithPath) {
            var url = optionsWithPath.url;
            var path = optionsWithPath.path;
            var apiRoot;
            if (typeof path === 'string') {
                apiRoot = rootURL;
                if (-1 !== rootURL.indexOf('?')) path = path.replace('?', '&');
                path = path.replace(/^\//, ''); // API root may already include query parameter prefix if site is
                // configured to use plain permalinks.
                if ('string' === typeof apiRoot && -1 !== apiRoot.indexOf('?')) path = path.replace('?', '&');
                url = apiRoot + path;
            }
            return next($e0191abbb9f255f1$var$_objectSpread($e0191abbb9f255f1$var$_objectSpread({}, optionsWithPath), {}, {
                url: url
            }));
        });
    };
};
var $e0191abbb9f255f1$export$2e2bcd8739ae039 = $e0191abbb9f255f1$var$createRootURLMiddleware;

});
parcelRegister("kA638", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $efbbdcbd723ccf41$export$2e2bcd8739ae039; });

var $lB7P9 = parcelRequire("lB7P9");
function $efbbdcbd723ccf41$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $efbbdcbd723ccf41$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $efbbdcbd723ccf41$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $lB7P9.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $efbbdcbd723ccf41$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * @type {import('../types').APIFetchMiddleware}
 */ var $efbbdcbd723ccf41$var$namespaceAndEndpointMiddleware = function namespaceAndEndpointMiddleware(options, next) {
    var path = options.path;
    var namespaceTrimmed, endpointTrimmed;
    if (typeof options.namespace === 'string' && typeof options.endpoint === 'string') {
        namespaceTrimmed = options.namespace.replace(/^\/|\/$/g, '');
        endpointTrimmed = options.endpoint.replace(/^\//, '');
        if (endpointTrimmed) path = namespaceTrimmed + '/' + endpointTrimmed;
        else path = namespaceTrimmed;
    }
    delete options.namespace;
    delete options.endpoint;
    return next($efbbdcbd723ccf41$var$_objectSpread($efbbdcbd723ccf41$var$_objectSpread({}, options), {}, {
        path: path
    }));
};
var $efbbdcbd723ccf41$export$2e2bcd8739ae039 = $efbbdcbd723ccf41$var$namespaceAndEndpointMiddleware;

});


parcelRegister("4pPMs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3371a9be8a9f43b6$export$2e2bcd8739ae039; });
/**
 * Given a path, returns a normalized path where equal query parameter values
 * will be treated as identical, regardless of order they appear in the original
 * text.
 *
 * @param {string} path Original path.
 *
 * @return {string} Normalized path.
 */ function $3371a9be8a9f43b6$export$7b4a09ff00acff9d(path) {
    var splitted = path.split('?');
    var query = splitted[1];
    var base = splitted[0];
    if (!query) return base;
     // 'b=1&c=2&a=5'
    return base + '?' + query // [ 'b=1', 'c=2', 'a=5' ]
    .split('&') // [ [ 'b, '1' ], [ 'c', '2' ], [ 'a', '5' ] ]
    .map(function(entry) {
        return entry.split('=');
    }) // [ [ 'a', '5' ], [ 'b, '1' ], [ 'c', '2' ] ]
    .sort(function(a, b) {
        return a[0].localeCompare(b[0]);
    }) // [ 'a=5', 'b=1', 'c=2' ]
    .map(function(pair) {
        return pair.join('=');
    }) // 'a=5&b=1&c=2'
    .join('&');
}
/**
 * @param {Record<string, any>} preloadedData
 * @return {import('../types').APIFetchMiddleware} Preloading middleware.
 */ function $3371a9be8a9f43b6$var$createPreloadingMiddleware(preloadedData) {
    var cache = Object.keys(preloadedData).reduce(function(result, path) {
        result[$3371a9be8a9f43b6$export$7b4a09ff00acff9d(path)] = preloadedData[path];
        return result;
    }, /** @type {Record<string, any>} */ {});
    return function(options, next) {
        var _options$parse = options.parse, parse = _options$parse === void 0 ? true : _options$parse;
        if (typeof options.path === 'string') {
            var method = options.method || 'GET';
            var path = $3371a9be8a9f43b6$export$7b4a09ff00acff9d(options.path);
            if ('GET' === method && cache[path]) {
                var cacheData = cache[path]; // Unsetting the cache key ensures that the data is only preloaded a single time
                delete cache[path];
                return Promise.resolve(parse ? cacheData.body : new window.Response(JSON.stringify(cacheData.body), {
                    status: 200,
                    statusText: 'OK',
                    headers: cacheData.headers
                }));
            } else if ('OPTIONS' === method && cache[method] && cache[method][path]) return Promise.resolve(cache[method][path]);
        }
        return next(options);
    };
}
var $3371a9be8a9f43b6$export$2e2bcd8739ae039 = $3371a9be8a9f43b6$var$createPreloadingMiddleware;

});

parcelRegister("9tXdA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e74c1f520c576df$export$2e2bcd8739ae039; });

var $laP2V = parcelRequire("laP2V");

var $lB7P9 = parcelRequire("lB7P9");

var $4nNod = parcelRequire("4nNod");

var $joUYv = parcelRequire("joUYv");

var $hYXju = parcelRequire("hYXju");

var $3TSey = parcelRequire("3TSey");
function $6e74c1f520c576df$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6e74c1f520c576df$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $6e74c1f520c576df$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $lB7P9.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $6e74c1f520c576df$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * Apply query arguments to both URL and Path, whichever is present.
 *
 * @param {import('../types').APIFetchOptions} props
 * @param {Record<string, string | number>} queryArgs
 * @return {import('../types').APIFetchOptions} The request with the modified query args
 */ var $6e74c1f520c576df$var$modifyQuery = function modifyQuery(_ref, queryArgs) {
    var path = _ref.path, url = _ref.url, options = (0, $4nNod.default)(_ref, [
        "path",
        "url"
    ]);
    return $6e74c1f520c576df$var$_objectSpread($6e74c1f520c576df$var$_objectSpread({}, options), {}, {
        url: url && (0, $hYXju.addQueryArgs)(url, queryArgs),
        path: path && (0, $hYXju.addQueryArgs)(path, queryArgs)
    });
};
/**
 * Duplicates parsing functionality from apiFetch.
 *
 * @param {Response} response
 * @return {Promise<any>} Parsed response json.
 */ var $6e74c1f520c576df$var$parseResponse = function parseResponse(response) {
    return response.json ? response.json() : Promise.reject(response);
};
/**
 * @param {string | null} linkHeader
 * @return {{ next?: string }} The parsed link header.
 */ var $6e74c1f520c576df$var$parseLinkHeader = function parseLinkHeader(linkHeader) {
    if (!linkHeader) return {};
    var match = linkHeader.match(/<([^>]+)>; rel="next"/);
    return match ? {
        next: match[1]
    } : {};
};
/**
 * @param {Response} response
 * @return {string | undefined} The next page URL.
 */ var $6e74c1f520c576df$var$getNextPageUrl = function getNextPageUrl(response) {
    var _parseLinkHeader = $6e74c1f520c576df$var$parseLinkHeader(response.headers.get('link')), next = _parseLinkHeader.next;
    return next;
};
/**
 * @param {import('../types').APIFetchOptions} options
 * @return {boolean} True if the request contains an unbounded query.
 */ var $6e74c1f520c576df$var$requestContainsUnboundedQuery = function requestContainsUnboundedQuery(options) {
    var pathIsUnbounded = !!options.path && options.path.indexOf('per_page=-1') !== -1;
    var urlIsUnbounded = !!options.url && options.url.indexOf('per_page=-1') !== -1;
    return pathIsUnbounded || urlIsUnbounded;
};
/**
 * The REST API enforces an upper limit on the per_page option. To handle large
 * collections, apiFetch consumers can pass `per_page=-1`; this middleware will
 * then recursively assemble a full response array from all available pages.
 *
 * @type {import('../types').APIFetchMiddleware}
 */ var $6e74c1f520c576df$var$fetchAllMiddleware = /*#__PURE__*/ function() {
    var _ref2 = (0, $laP2V.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($joUYv))).mark(function _callee(options, next) {
        var response, results, nextPage, mergedResults, nextResponse, nextResults;
        return (0, (/*@__PURE__*/$parcel$interopDefault($joUYv))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!(options.parse === false)) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return", next(options));
                case 2:
                    if ($6e74c1f520c576df$var$requestContainsUnboundedQuery(options)) {
                        _context.next = 4;
                        break;
                    }
                    return _context.abrupt("return", next(options));
                case 4:
                    _context.next = 6;
                    return (0, $3TSey.default)($6e74c1f520c576df$var$_objectSpread($6e74c1f520c576df$var$_objectSpread({}, $6e74c1f520c576df$var$modifyQuery(options, {
                        per_page: 100
                    })), {}, {
                        // Ensure headers are returned for page 1.
                        parse: false
                    }));
                case 6:
                    response = _context.sent;
                    _context.next = 9;
                    return $6e74c1f520c576df$var$parseResponse(response);
                case 9:
                    results = _context.sent;
                    if (Array.isArray(results)) {
                        _context.next = 12;
                        break;
                    }
                    return _context.abrupt("return", results);
                case 12:
                    nextPage = $6e74c1f520c576df$var$getNextPageUrl(response);
                    if (nextPage) {
                        _context.next = 15;
                        break;
                    }
                    return _context.abrupt("return", results);
                case 15:
                    // Iteratively fetch all remaining pages until no "next" header is found.
                    mergedResults = /** @type {any[]} */ [].concat(results);
                case 16:
                    if (!nextPage) {
                        _context.next = 27;
                        break;
                    }
                    _context.next = 19;
                    return (0, $3TSey.default)($6e74c1f520c576df$var$_objectSpread($6e74c1f520c576df$var$_objectSpread({}, options), {}, {
                        // Ensure the URL for the next page is used instead of any provided path.
                        path: undefined,
                        url: nextPage,
                        // Ensure we still get headers so we can identify the next page.
                        parse: false
                    }));
                case 19:
                    nextResponse = _context.sent;
                    _context.next = 22;
                    return $6e74c1f520c576df$var$parseResponse(nextResponse);
                case 22:
                    nextResults = _context.sent;
                    mergedResults = mergedResults.concat(nextResults);
                    nextPage = $6e74c1f520c576df$var$getNextPageUrl(nextResponse);
                    _context.next = 16;
                    break;
                case 27:
                    return _context.abrupt("return", mergedResults);
                case 28:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function fetchAllMiddleware(_x, _x2) {
        return _ref2.apply(this, arguments);
    };
}();
var $6e74c1f520c576df$export$2e2bcd8739ae039 = $6e74c1f520c576df$var$fetchAllMiddleware;

});
parcelRegister("laP2V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6a220d866f3658d$export$2e2bcd8739ae039; });
function $f6a220d866f3658d$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $f6a220d866f3658d$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $f6a220d866f3658d$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $f6a220d866f3658d$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

});

parcelRegister("joUYv", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $e1fc74389179ae7b$var$runtime = (parcelRequire("hWp4C"))();
module.exports = $e1fc74389179ae7b$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $e1fc74389179ae7b$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $e1fc74389179ae7b$var$runtime;
    else Function("r", "regeneratorRuntime = r")($e1fc74389179ae7b$var$runtime);
}

});
parcelRegister("hWp4C", function(module, exports) {

var $9tAbH = parcelRequire("9tAbH");

var $kqNDM = parcelRequire("kqNDM");

var $fmCIv = parcelRequire("fmCIv");

var $bfFTZ = parcelRequire("bfFTZ");

var $lvMAg = parcelRequire("lvMAg");

var $ccJA3 = parcelRequire("ccJA3");

var $jxRB2 = parcelRequire("jxRB2");
function $d0fb4d88eb41fb5f$var$_regeneratorRuntime() {
    "use strict";
    var r = $kqNDM(), e = r.m($d0fb4d88eb41fb5f$var$_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, $jxRB2(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return (module.exports = $d0fb4d88eb41fb5f$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new $9tAbH(r, e);
            },
            AsyncIterator: $lvMAg,
            async: function async(r, e, t, o, u) {
                return (n(e) ? $bfFTZ : $fmCIv)(a(r), e, t, o, u);
            },
            keys: $ccJA3,
            values: $jxRB2
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $d0fb4d88eb41fb5f$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("9tAbH", function(module, exports) {
function $6e62e497c4567fe2$var$_OverloadYield(e, d) {
    this.v = e, this.k = d;
}
module.exports = $6e62e497c4567fe2$var$_OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kqNDM", function(module, exports) {

var $4TVDd = parcelRequire("4TVDd");
function $edfcbdf3e5d5be78$var$_regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return $4TVDd(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ($4TVDd(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, $4TVDd(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, $4TVDd(u, "constructor", GeneratorFunctionPrototype), $4TVDd(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", $4TVDd(GeneratorFunctionPrototype, o, "GeneratorFunction"), $4TVDd(u), $4TVDd(u, o, "Generator"), $4TVDd(u, n, function() {
        return this;
    }), $4TVDd(u, "toString", function() {
        return "[object Generator]";
    }), (module.exports = $edfcbdf3e5d5be78$var$_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $edfcbdf3e5d5be78$var$_regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("4TVDd", function(module, exports) {
function $391900e37fc3da5e$var$_regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    module.exports = $391900e37fc3da5e$var$_regeneratorDefine = function regeneratorDefine(e, r, n, t) {
        function o(r, n) {
            $391900e37fc3da5e$var$_regeneratorDefine(e, r, function(e) {
                return this._invoke(r, n, e);
            });
        }
        r ? i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $391900e37fc3da5e$var$_regeneratorDefine(e, r, n, t);
}
module.exports = $391900e37fc3da5e$var$_regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("fmCIv", function(module, exports) {

var $bfFTZ = parcelRequire("bfFTZ");
function $02e2f360ba3c69a8$var$_regeneratorAsync(n, e, r, t, o) {
    var a = $bfFTZ(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}
module.exports = $02e2f360ba3c69a8$var$_regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("bfFTZ", function(module, exports) {

var $kqNDM = parcelRequire("kqNDM");

var $lvMAg = parcelRequire("lvMAg");
function $021d2fe43f5abbab$var$_regeneratorAsyncGen(r, e, t, o, n) {
    return new $lvMAg($kqNDM().w(r, e, t, o), n || Promise);
}
module.exports = $021d2fe43f5abbab$var$_regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("lvMAg", function(module, exports) {

var $9tAbH = parcelRequire("9tAbH");

var $4TVDd = parcelRequire("4TVDd");
function $fa922df5cf1b6960$var$AsyncIterator(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof $9tAbH ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ($4TVDd($fa922df5cf1b6960$var$AsyncIterator.prototype), $4TVDd($fa922df5cf1b6960$var$AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), $4TVDd(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}
module.exports = $fa922df5cf1b6960$var$AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("ccJA3", function(module, exports) {
function $8e29f65d1d8b2078$var$_regeneratorKeys(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}
module.exports = $8e29f65d1d8b2078$var$_regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("jxRB2", function(module, exports) {

var $5OoXb = parcelRequire("5OoXb");
var $e3aaac7f7a3cea58$var$_typeof = $5OoXb.default;
function $e3aaac7f7a3cea58$var$_regeneratorValues(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError($e3aaac7f7a3cea58$var$_typeof(e) + " is not iterable");
}
module.exports = $e3aaac7f7a3cea58$var$_regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5OoXb", function(module, exports) {
function $43b4fa80efde8fb9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $43b4fa80efde8fb9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $43b4fa80efde8fb9$var$_typeof(o);
}
module.exports = $43b4fa80efde8fb9$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("hYXju", function(module, exports) {

$parcel$export(module.exports, "addQueryArgs", function () { return $d1760ca9f8731a1c$export$c06457cd72751986; });
/**
 * Internal dependencies
 */ 
var $a0bSI = parcelRequire("a0bSI");

var $8AvtB = parcelRequire("8AvtB");
function $d1760ca9f8731a1c$export$c06457cd72751986() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var args = arguments.length > 1 ? arguments[1] : undefined;
    // If no arguments are to be appended, return original URL.
    if (!args || !Object.keys(args).length) return url;
    var baseUrl = url; // Determine whether URL already had query arguments.
    var queryStringIndex = url.indexOf('?');
    if (queryStringIndex !== -1) {
        // Merge into existing query arguments.
        args = Object.assign((0, $a0bSI.getQueryArgs)(url), args); // Change working base URL to omit previous query arguments.
        baseUrl = baseUrl.substr(0, queryStringIndex);
    }
    return baseUrl + '?' + (0, $8AvtB.buildQueryString)(args);
}

});
parcelRegister("a0bSI", function(module, exports) {

$parcel$export(module.exports, "getQueryArgs", function () { return $74831ee8b0401396$export$ae70ac52a8fdec95; });

var $e3xqi = parcelRequire("e3xqi");

var $lB7P9 = parcelRequire("lB7P9");

var $5mojb = parcelRequire("5mojb");
function $74831ee8b0401396$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $74831ee8b0401396$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $74831ee8b0401396$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $lB7P9.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $74831ee8b0401396$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/** @typedef {import('./get-query-arg').QueryArgParsed} QueryArgParsed */ /**
 * @typedef {Record<string,QueryArgParsed>} QueryArgs
 */ /**
 * Sets a value in object deeply by a given array of path segments. Mutates the
 * object reference.
 *
 * @param {Record<string,*>} object Object in which to assign.
 * @param {string[]}         path   Path segment at which to set value.
 * @param {*}                value  Value to set.
 */ function $74831ee8b0401396$var$setPath(object, path, value) {
    var length = path.length;
    var lastIndex = length - 1;
    for(var i = 0; i < length; i++){
        var key = path[i];
        if (!key && Array.isArray(object)) // If key is empty string and next value is array, derive key from
        // the current length of the array.
        key = object.length.toString();
         // If the next key in the path is numeric (or empty string), it will be
        // created as an array. Otherwise, it will be created as an object.
        var isNextKeyArrayIndex = !isNaN(Number(path[i + 1]));
        object[key] = i === lastIndex ? value : // it if it does not yet exist.
        object[key] || (isNextKeyArrayIndex ? [] : {});
        if (Array.isArray(object[key]) && !isNextKeyArrayIndex) // If we current key is non-numeric, but the next value is an
        // array, coerce the value to an object.
        object[key] = $74831ee8b0401396$var$_objectSpread({}, object[key]);
         // Update working reference object to the next in the path.
        object = object[key];
    }
}
function $74831ee8b0401396$export$ae70ac52a8fdec95(url) {
    return ((0, $5mojb.getQueryString)(url) || '').// corresponding to `application/x-www-form-urlencoded`.
    //
    // See: https://tools.ietf.org/html/rfc1866#section-8.2.1
    replace(/\+/g, '%20').split('&').reduce(function(accumulator, keyValue) {
        var _keyValue$split$filte = keyValue.split('=') // Filtering avoids decoding as `undefined` for value, where
        // default is restored in destructuring assignment.
        .filter(Boolean).map(decodeURIComponent), _keyValue$split$filte2 = (0, $e3xqi.default)(_keyValue$split$filte, 2), key = _keyValue$split$filte2[0], _keyValue$split$filte3 = _keyValue$split$filte2[1], value = _keyValue$split$filte3 === void 0 ? '' : _keyValue$split$filte3;
        if (key) {
            var segments = key.replace(/\]/g, '').split('[');
            $74831ee8b0401396$var$setPath(accumulator, segments, value);
        }
        return accumulator;
    }, {});
}

});
parcelRegister("e3xqi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3bb459d6a973ea1$export$2e2bcd8739ae039; });

var $bCmUc = parcelRequire("bCmUc");

var $oKd0e = parcelRequire("oKd0e");

var $45CPT = parcelRequire("45CPT");

var $12fni = parcelRequire("12fni");
function $a3bb459d6a973ea1$export$2e2bcd8739ae039(r, e) {
    return (0, $bCmUc.default)(r) || (0, $oKd0e.default)(r, e) || (0, $45CPT.default)(r, e) || (0, $12fni.default)();
}

});
parcelRegister("bCmUc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $875502dcf1b945d9$export$2e2bcd8739ae039; });
function $875502dcf1b945d9$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("oKd0e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04a616184d319d1c$export$2e2bcd8739ae039; });
function $04a616184d319d1c$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("12fni", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c11e77327771c10$export$2e2bcd8739ae039; });
function $0c11e77327771c10$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("5mojb", function(module, exports) {

$parcel$export(module.exports, "getQueryString", function () { return $3e71dcf147697f9f$export$18380b9f669996bd; });
/**
 * Returns the query string part of the URL.
 *
 * @param {string} url The full URL.
 *
 * @example
 * ```js
 * const queryString = getQueryString( 'http://localhost:8080/this/is/a/test?query=true#fragment' ); // 'query=true'
 * ```
 *
 * @return {string|void} The query string part of the URL.
 */ function $3e71dcf147697f9f$export$18380b9f669996bd(url) {
    var query;
    try {
        query = new URL(url, 'http://example.com').search.substring(1);
    } catch (error) {}
    if (query) return query;
}

});


parcelRegister("8AvtB", function(module, exports) {

$parcel$export(module.exports, "buildQueryString", function () { return $640a1a182f744ce0$export$6b17a39e52c8ee53; });

var $e3xqi = parcelRequire("e3xqi");
function $640a1a182f744ce0$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (it = $640a1a182f744ce0$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = o[Symbol.iterator]();
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $640a1a182f744ce0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $640a1a182f744ce0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $640a1a182f744ce0$var$_arrayLikeToArray(o, minLen);
}
function $640a1a182f744ce0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $640a1a182f744ce0$export$6b17a39e52c8ee53(data) {
    var string = '';
    var stack = Object.entries(data);
    var pair;
    while(pair = stack.shift()){
        var _pair = pair, _pair2 = (0, $e3xqi.default)(_pair, 2), key = _pair2[0], value = _pair2[1]; // Support building deeply nested data, from array or object values.
        var hasNestedData = Array.isArray(value) || value && value.constructor === Object;
        if (hasNestedData) {
            // Push array or object values onto the stack as composed of their
            // original key and nested index or key, retaining order by a
            // combination of Array#reverse and Array#unshift onto the stack.
            var valuePairs = Object.entries(value).reverse();
            var _iterator = $640a1a182f744ce0$var$_createForOfIteratorHelper(valuePairs), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var _step$value = (0, $e3xqi.default)(_step.value, 2), member = _step$value[0], memberValue = _step$value[1];
                    stack.unshift([
                        "".concat(key, "[").concat(member, "]"),
                        memberValue
                    ]);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        } else if (value !== undefined) {
            // Null is treated as special case, equivalent to empty string.
            if (value === null) value = '';
            string += '&' + [
                key,
                value
            ].map(encodeURIComponent).join('=');
        }
    } // Loop will concatenate with leading `&`, but it's only expected for all
    // but the first query parameter. This strips the leading `&`, while still
    // accounting for the case that the string may in-fact be empty.
    return string.substr(1);
}

});



parcelRegister("7uiCi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5739c6a00b9dc4ee$export$2e2bcd8739ae039; });

var $lB7P9 = parcelRequire("lB7P9");
function $5739c6a00b9dc4ee$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5739c6a00b9dc4ee$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $5739c6a00b9dc4ee$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $lB7P9.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $5739c6a00b9dc4ee$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * Set of HTTP methods which are eligible to be overridden.
 *
 * @type {Set<string>}
 */ var $5739c6a00b9dc4ee$var$OVERRIDE_METHODS = new Set([
    'PATCH',
    'PUT',
    'DELETE'
]);
/**
 * Default request method.
 *
 * "A request has an associated method (a method). Unless stated otherwise it
 * is `GET`."
 *
 * @see  https://fetch.spec.whatwg.org/#requests
 *
 * @type {string}
 */ var $5739c6a00b9dc4ee$var$DEFAULT_METHOD = 'GET';
/**
 * API Fetch middleware which overrides the request method for HTTP v1
 * compatibility leveraging the REST API X-HTTP-Method-Override header.
 *
 * @type {import('../types').APIFetchMiddleware}
 */ var $5739c6a00b9dc4ee$var$httpV1Middleware = function httpV1Middleware(options, next) {
    var _options = options, _options$method = _options.method, method = _options$method === void 0 ? $5739c6a00b9dc4ee$var$DEFAULT_METHOD : _options$method;
    if ($5739c6a00b9dc4ee$var$OVERRIDE_METHODS.has(method.toUpperCase())) options = $5739c6a00b9dc4ee$var$_objectSpread($5739c6a00b9dc4ee$var$_objectSpread({}, options), {}, {
        headers: $5739c6a00b9dc4ee$var$_objectSpread($5739c6a00b9dc4ee$var$_objectSpread({}, options.headers), {}, {
            'X-HTTP-Method-Override': method,
            'Content-Type': 'application/json'
        }),
        method: 'POST'
    });
    return next(options);
};
var $5739c6a00b9dc4ee$export$2e2bcd8739ae039 = $5739c6a00b9dc4ee$var$httpV1Middleware;

});

parcelRegister("lfMVe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f790f29487e18fef$export$2e2bcd8739ae039; });
/**
 * WordPress dependencies
 */ 
var $hYXju = parcelRequire("hYXju");
var $ebeME = parcelRequire("ebeME");
/**
 * @type {import('../types').APIFetchMiddleware}
 */ var $f790f29487e18fef$var$userLocaleMiddleware = function userLocaleMiddleware(options, next) {
    if (typeof options.url === 'string' && !(0, $ebeME.hasQueryArg)(options.url, '_locale')) options.url = (0, $hYXju.addQueryArgs)(options.url, {
        _locale: 'user'
    });
    if (typeof options.path === 'string' && !(0, $ebeME.hasQueryArg)(options.path, '_locale')) options.path = (0, $hYXju.addQueryArgs)(options.path, {
        _locale: 'user'
    });
    return next(options);
};
var $f790f29487e18fef$export$2e2bcd8739ae039 = $f790f29487e18fef$var$userLocaleMiddleware;

});
parcelRegister("ebeME", function(module, exports) {

$parcel$export(module.exports, "hasQueryArg", function () { return $a52d8f7ce8be0a7c$export$3c0fa5651fd37aa; });
/**
 * Internal dependencies
 */ 
var $kqxp7 = parcelRequire("kqxp7");
function $a52d8f7ce8be0a7c$export$3c0fa5651fd37aa(url, arg) {
    return (0, $kqxp7.getQueryArg)(url, arg) !== undefined;
}

});
parcelRegister("kqxp7", function(module, exports) {

$parcel$export(module.exports, "getQueryArg", function () { return $edf025b38c65f5b7$export$75df27fc0a35b321; });
/**
 * Internal dependencies
 */ 
var $a0bSI = parcelRequire("a0bSI");
function $edf025b38c65f5b7$export$75df27fc0a35b321(url, arg) {
    return (0, $a0bSI.getQueryArgs)(url)[arg];
}

});



parcelRegister("88Zkf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5edea41465773c0e$export$2e2bcd8739ae039; });

var $lB7P9 = parcelRequire("lB7P9");
parcelRequire("5hZ7V");
var $lw5wl = parcelRequire("lw5wl");

var $5XIr7 = parcelRequire("5XIr7");
function $5edea41465773c0e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5edea41465773c0e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $5edea41465773c0e$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $lB7P9.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $5edea41465773c0e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * Middleware handling media upload failures and retries.
 *
 * @type {import('../types').APIFetchMiddleware}
 */ var $5edea41465773c0e$var$mediaUploadMiddleware = function mediaUploadMiddleware(options, next) {
    var isMediaUploadRequest = options.path && options.path.indexOf('/wp/v2/media') !== -1 || options.url && options.url.indexOf('/wp/v2/media') !== -1;
    if (!isMediaUploadRequest) return next(options);
    var retries = 0;
    var maxRetries = 5;
    /**
   * @param {string} attachmentId
   * @return {Promise<any>} Processed post response.
   */ var postProcess = function postProcess(attachmentId) {
        retries++;
        return next({
            path: "/wp/v2/media/".concat(attachmentId, "/post-process"),
            method: 'POST',
            data: {
                action: 'create-image-subsizes'
            },
            parse: false
        }).catch(function() {
            if (retries < maxRetries) return postProcess(attachmentId);
            next({
                path: "/wp/v2/media/".concat(attachmentId, "?force=true"),
                method: 'DELETE'
            });
            return Promise.reject();
        });
    };
    return next($5edea41465773c0e$var$_objectSpread($5edea41465773c0e$var$_objectSpread({}, options), {}, {
        parse: false
    })).catch(function(response) {
        var attachmentId = response.headers.get('x-wp-upload-attachment-id');
        if (response.status >= 500 && response.status < 600 && attachmentId) return postProcess(attachmentId).catch(function() {
            if (options.parse !== false) return Promise.reject({
                code: 'post_process',
                message: (0, $lw5wl.__)('Media upload failed. If this is a photo or a large image, please scale it down and try again.')
            });
            return Promise.reject(response);
        });
        return (0, $5XIr7.parseAndThrowError)(response, options.parse);
    }).then(function(response) {
        return (0, $5XIr7.parseResponseAndNormalizeError)(response, options.parse);
    });
};
var $5edea41465773c0e$export$2e2bcd8739ae039 = $5edea41465773c0e$var$mediaUploadMiddleware;

});
parcelRegister("5XIr7", function(module, exports) {

$parcel$export(module.exports, "parseResponseAndNormalizeError", function () { return $4574ee99ff9a903c$export$7f4dc73e58eeb853; });
$parcel$export(module.exports, "parseAndThrowError", function () { return $4574ee99ff9a903c$export$af91b101bc689703; });
/**
 * WordPress dependencies
 */ parcelRequire("5hZ7V");
var $lw5wl = parcelRequire("lw5wl");
/**
 * Parses the apiFetch response.
 *
 * @param {Response} response
 * @param {boolean}  shouldParseResponse
 *
 * @return {Promise<any> | null | Response} Parsed response.
 */ var $4574ee99ff9a903c$var$parseResponse = function parseResponse(response) {
    var shouldParseResponse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (shouldParseResponse) {
        if (response.status === 204) return null;
        return response.json ? response.json() : Promise.reject(response);
    }
    return response;
};
/**
 * Calls the `json` function on the Response, throwing an error if the response
 * doesn't have a json function or if parsing the json itself fails.
 *
 * @param {Response} response
 * @return {Promise<any>} Parsed response.
 */ var $4574ee99ff9a903c$var$parseJsonAndNormalizeError = function parseJsonAndNormalizeError(response) {
    var invalidJsonError = {
        code: 'invalid_json',
        message: (0, $lw5wl.__)('The response is not a valid JSON response.')
    };
    if (!response || !response.json) throw invalidJsonError;
    return response.json().catch(function() {
        throw invalidJsonError;
    });
};
var $4574ee99ff9a903c$export$7f4dc73e58eeb853 = function parseResponseAndNormalizeError(response) {
    var shouldParseResponse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return Promise.resolve($4574ee99ff9a903c$var$parseResponse(response, shouldParseResponse)).catch(function(res) {
        return $4574ee99ff9a903c$export$af91b101bc689703(res, shouldParseResponse);
    });
};
function $4574ee99ff9a903c$export$af91b101bc689703(response) {
    var shouldParseResponse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (!shouldParseResponse) throw response;
    return $4574ee99ff9a903c$var$parseJsonAndNormalizeError(response).then(function(error) {
        var unknownError = {
            code: 'unknown_error',
            message: (0, $lw5wl.__)('An unknown error occurred.')
        };
        throw error || unknownError;
    });
}

});




parcelRegister("5QtRe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $660555179126b727$var$Grid;

var $22Tm6 = parcelRequire("22Tm6");

var $jURgU = parcelRequire("jURgU");

var $660555179126b727$var$_GridItem = $660555179126b727$var$_interopRequireDefault((parcelRequire("dROUv")));

var $660555179126b727$var$_PlaceholderGridItem = $660555179126b727$var$_interopRequireDefault((parcelRequire("97xNZ")));

var $daeNZ = parcelRequire("daeNZ");
function $660555179126b727$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const { Suspense: $660555179126b727$var$Suspense, use: $660555179126b727$var$use } = window.React;
const $660555179126b727$var$GRID_ITEM_CLASSES = "col-xl-4 col-lg-4 col-md-6 col-12 mb-4 position-relative";
function $660555179126b727$var$AsyncGrid() {
    const { postsPromise: postsPromise, resetFilters: resetFilters } = (0, $jURgU.useAppContext)();
    const posts = $660555179126b727$var$use(postsPromise);
    if (posts.length === 0) return /*#__PURE__*/ React.createElement("button", {
        type: "button",
        className: "link-reset font-weight-bold btn btn-link text-primary",
        onClick: resetFilters
    }, "No posts found. Click here to reset filters.");
    return posts.map((post)=>/*#__PURE__*/ React.createElement($660555179126b727$var$_GridItem.default, {
            key: `post-id-${post.ID}`,
            post: post,
            gridItemClasses: $660555179126b727$var$GRID_ITEM_CLASSES
        }));
}
function $660555179126b727$var$GridPlaceholders({ count: count }) {
    return Array.from({
        length: count
    }).map((_, idx)=>/*#__PURE__*/ React.createElement("div", {
            key: `placeholder-${idx}`,
            className: `${$660555179126b727$var$GRID_ITEM_CLASSES} resource-hub-grid-item card-appear pre-enter`
        }, /*#__PURE__*/ React.createElement($660555179126b727$var$_PlaceholderGridItem.default, null)));
}
function $660555179126b727$var$Grid() {
    const { postsRef: postsRef } = (0, $jURgU.useAppContext)();
    const transitionMap = (0, $22Tm6.useTransitionMap)({
        mountOnEnter: true,
        unmountOnExit: true,
        allowMultiple: true,
        initialEntered: false,
        timeout: 400,
        preEnter: true,
        preExit: true
    });
    const placeholderCount = postsRef.current.length <= 1 ? 6 : 3;
    return /*#__PURE__*/ React.createElement($daeNZ.TransitionProvider, {
        value: transitionMap
    }, /*#__PURE__*/ React.createElement("div", {
        className: "col-lg-12 col-xl-9 col-12 my-4 px-4 px-lg-3"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "row"
    }, /*#__PURE__*/ React.createElement($660555179126b727$var$Suspense, {
        fallback: /*#__PURE__*/ React.createElement(React.Fragment, null, postsRef.current.map((post)=>/*#__PURE__*/ React.createElement($660555179126b727$var$_GridItem.default, {
                key: `post-id-${post.ID}`,
                post: post,
                gridItemClasses: $660555179126b727$var$GRID_ITEM_CLASSES
            })), /*#__PURE__*/ React.createElement($660555179126b727$var$GridPlaceholders, {
            count: placeholderCount
        }))
    }, /*#__PURE__*/ React.createElement($660555179126b727$var$AsyncGrid, null)))));
}

});
parcelRegister("22Tm6", function(module, exports) {

$parcel$export(module.exports, "useTransitionMap", function () { return $625cd93fd7a860e8$export$862f01b9eab704ad; });

var $dGL81 = parcelRequire("dGL81");

var $exYeM = parcelRequire("exYeM");
//#region src/useTransitionMap.ts
const $625cd93fd7a860e8$var$updateState = (key, status, setStateMap, ref, config, onChange)=>{
    if (config) {
        clearTimeout(config.t);
        cancelAnimationFrame(config.r);
    }
    const state = (0, $dGL81.getState)(status);
    const stateMap = new Map(ref.m);
    stateMap.set(key, state);
    setStateMap(stateMap);
    ref.m = stateMap;
    onChange?.({
        key: key,
        current: state
    });
};
const $625cd93fd7a860e8$export$862f01b9eab704ad = ({ allowMultiple: allowMultiple, enter: enter = true, exit: exit = true, preEnter: preEnter, preExit: preExit, timeout: timeout, initialEntered: initialEntered, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit, onStateChange: onChange } = {})=>{
    const [stateMap, setStateMap] = (0, $exYeM.useState)(/* @__PURE__ */ new Map());
    const [ref] = (0, $exYeM.useState)({
        m: stateMap,
        c: /* @__PURE__ */ new Map()
    });
    const [enterTimeout, exitTimeout] = (0, $dGL81.getTimeout)(timeout);
    const setItem = (0, $exYeM.useCallback)((key, options)=>{
        const { initialEntered: _initialEntered = initialEntered } = options || {};
        $625cd93fd7a860e8$var$updateState(key, _initialEntered ? 2 : (0, $dGL81.startOrEnd)(mountOnEnter), setStateMap, ref);
        ref.c.set(key, {
            r: 0
        });
    }, [
        initialEntered,
        mountOnEnter,
        ref
    ]);
    const deleteItem = (0, $exYeM.useCallback)((key)=>{
        const newStateMap = new Map(ref.m);
        if (newStateMap.delete(key)) {
            setStateMap(newStateMap);
            ref.m = newStateMap;
            ref.c.delete(key);
            return true;
        }
        return false;
    }, [
        ref
    ]);
    const endTransition = (0, $exYeM.useCallback)((key)=>{
        const state = ref.m.get(key);
        if (!state) return;
        const status = (0, $dGL81.getEndStatus)(state.$, unmountOnExit);
        if (status) $625cd93fd7a860e8$var$updateState(key, status, setStateMap, ref, ref.c.get(key), onChange);
    }, [
        onChange,
        unmountOnExit,
        ref
    ]);
    const toggle = (0, $exYeM.useCallback)((key, toEnter)=>{
        const state = ref.m.get(key);
        if (!state) return;
        const config = ref.c.get(key);
        const transitState = (status)=>{
            $625cd93fd7a860e8$var$updateState(key, status, setStateMap, ref, config, onChange);
            switch(status){
                case 1:
                    if (enterTimeout >= 0) config.t = setTimeout(()=>endTransition(key), enterTimeout);
                    break;
                case 4:
                    if (exitTimeout >= 0) config.t = setTimeout(()=>endTransition(key), exitTimeout);
                    break;
                case 0:
                case 3:
                    (0, $dGL81.nextTick)(()=>transitState(status + 1), config);
                    break;
            }
        };
        const enterStage = state.isEnter;
        if (typeof toEnter !== "boolean") toEnter = !enterStage;
        if (toEnter) {
            if (!enterStage) {
                transitState(enter ? preEnter ? 0 : 1 : 2);
                if (!allowMultiple) ref.m.forEach((_, _key)=>_key !== key && toggle(_key, false));
            }
        } else if (enterStage) transitState(exit ? preExit ? 3 : 4 : (0, $dGL81.startOrEnd)(unmountOnExit));
    }, [
        ref,
        onChange,
        endTransition,
        allowMultiple,
        enter,
        exit,
        preEnter,
        preExit,
        enterTimeout,
        exitTimeout,
        unmountOnExit
    ]);
    return {
        stateMap: stateMap,
        toggle: toggle,
        toggleAll: (0, $exYeM.useCallback)((toEnter)=>{
            if (!allowMultiple && toEnter !== false) return;
            for (const key of ref.m.keys())toggle(key, toEnter);
        }, [
            allowMultiple,
            toggle,
            ref
        ]),
        endTransition: endTransition,
        setItem: setItem,
        deleteItem: deleteItem
    };
};

});
parcelRegister("dGL81", function(module, exports) {

$parcel$export(module.exports, "getState", function () { return $f06864e50484d9f4$export$50fdfeece43146fd; });
$parcel$export(module.exports, "startOrEnd", function () { return $f06864e50484d9f4$export$eb0971344425f03e; });
$parcel$export(module.exports, "getEndStatus", function () { return $f06864e50484d9f4$export$c9efa50dd559122e; });
$parcel$export(module.exports, "getTimeout", function () { return $f06864e50484d9f4$export$d2e3f47e67110e3a; });
$parcel$export(module.exports, "nextTick", function () { return $f06864e50484d9f4$export$bdd553fddd433dcb; });
const $f06864e50484d9f4$var$STATUS = [
    "preEnter",
    "entering",
    "entered",
    "preExit",
    "exiting",
    "exited",
    "unmounted"
];
const $f06864e50484d9f4$export$50fdfeece43146fd = (status)=>({
        $: status,
        status: $f06864e50484d9f4$var$STATUS[status],
        isEnter: status < 3,
        isMounted: status !== 6,
        isResolved: status === 2 || status > 4
    });
const $f06864e50484d9f4$export$eb0971344425f03e = (unmounted)=>unmounted ? 6 : 5;
const $f06864e50484d9f4$export$c9efa50dd559122e = (status, unmountOnExit)=>{
    switch(status){
        case 1:
        case 0:
            return 2;
        case 4:
        case 3:
            return $f06864e50484d9f4$export$eb0971344425f03e(unmountOnExit);
    }
};
const $f06864e50484d9f4$export$d2e3f47e67110e3a = (timeout)=>typeof timeout === "object" ? [
        timeout.enter,
        timeout.exit
    ] : [
        timeout,
        timeout
    ];
const $f06864e50484d9f4$export$bdd553fddd433dcb = (callback, config)=>{
    config.r = requestAnimationFrame(()=>{
        config.r = requestAnimationFrame(callback);
    });
};

});

parcelRegister("exYeM", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gfHYB"));

});
parcelRegister("gfHYB", function(module, exports) {

$parcel$export(module.exports, "Activity", function () { return $bd5028e33dce7343$export$9c16c1426311996d; }, function (v) { return $bd5028e33dce7343$export$9c16c1426311996d = v; });
$parcel$export(module.exports, "Children", function () { return $bd5028e33dce7343$export$dca3b0875bd9a954; }, function (v) { return $bd5028e33dce7343$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $bd5028e33dce7343$export$16fa2f45be04daa8; }, function (v) { return $bd5028e33dce7343$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $bd5028e33dce7343$export$ffb0004e005737fa; }, function (v) { return $bd5028e33dce7343$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $bd5028e33dce7343$export$e2c29f18771995cb; }, function (v) { return $bd5028e33dce7343$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $bd5028e33dce7343$export$221d75b3f55bb0bd; }, function (v) { return $bd5028e33dce7343$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $bd5028e33dce7343$export$5f8d39834fd61797; }, function (v) { return $bd5028e33dce7343$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $bd5028e33dce7343$export$74bf444e3cd11ea5; }, function (v) { return $bd5028e33dce7343$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $bd5028e33dce7343$export$1ced07cd6b1985ce; }, function (v) { return $bd5028e33dce7343$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $bd5028e33dce7343$export$abd8e32b826d7ea7; }, function (v) { return $bd5028e33dce7343$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "cache", function () { return $bd5028e33dce7343$export$69a3209f1a06c04d; }, function (v) { return $bd5028e33dce7343$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cacheSignal", function () { return $bd5028e33dce7343$export$8c538325882c7eec; }, function (v) { return $bd5028e33dce7343$export$8c538325882c7eec = v; });
$parcel$export(module.exports, "cloneElement", function () { return $bd5028e33dce7343$export$e530037191fcd5d7; }, function (v) { return $bd5028e33dce7343$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $bd5028e33dce7343$export$fd42f52fd3ae1109; }, function (v) { return $bd5028e33dce7343$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $bd5028e33dce7343$export$c8a8987d4410bf2d; }, function (v) { return $bd5028e33dce7343$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $bd5028e33dce7343$export$7d1e3a5e95ceca43; }, function (v) { return $bd5028e33dce7343$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $bd5028e33dce7343$export$257a8862b851cb5b; }, function (v) { return $bd5028e33dce7343$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $bd5028e33dce7343$export$a8257692ac88316c; }, function (v) { return $bd5028e33dce7343$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $bd5028e33dce7343$export$488013bae63b21da; }, function (v) { return $bd5028e33dce7343$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $bd5028e33dce7343$export$7c73462e0d25e514; }, function (v) { return $bd5028e33dce7343$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $bd5028e33dce7343$export$7568632d0d33d16d; }, function (v) { return $bd5028e33dce7343$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $bd5028e33dce7343$export$f93f40ac0ca7e3a8; }, function (v) { return $bd5028e33dce7343$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $bd5028e33dce7343$export$1f96ae73734a86cc; }, function (v) { return $bd5028e33dce7343$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $bd5028e33dce7343$export$9a47ced3238df325; }, function (v) { return $bd5028e33dce7343$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $bd5028e33dce7343$export$35808ee640e87ca7; }, function (v) { return $bd5028e33dce7343$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $bd5028e33dce7343$export$fae74005e78b1a27; }, function (v) { return $bd5028e33dce7343$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $bd5028e33dce7343$export$dc8fbce3eb94dc1e; }, function (v) { return $bd5028e33dce7343$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $bd5028e33dce7343$export$6a7bc4e911dc01cf; }, function (v) { return $bd5028e33dce7343$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $bd5028e33dce7343$export$6d9c69b0de29b591; }, function (v) { return $bd5028e33dce7343$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useEffectEvent", function () { return $bd5028e33dce7343$export$7f54fc3180508a52; }, function (v) { return $bd5028e33dce7343$export$7f54fc3180508a52 = v; });
$parcel$export(module.exports, "useId", function () { return $bd5028e33dce7343$export$f680877a34711e37; }, function (v) { return $bd5028e33dce7343$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $bd5028e33dce7343$export$d5a552a76deda3c2; }, function (v) { return $bd5028e33dce7343$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $bd5028e33dce7343$export$aaabe4eda9ed9969; }, function (v) { return $bd5028e33dce7343$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $bd5028e33dce7343$export$e5c5a5f917a5871c; }, function (v) { return $bd5028e33dce7343$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $bd5028e33dce7343$export$1538c33de8887b59; }, function (v) { return $bd5028e33dce7343$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $bd5028e33dce7343$export$fca7f784ae7a249a; }, function (v) { return $bd5028e33dce7343$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $bd5028e33dce7343$export$13e3392192263954; }, function (v) { return $bd5028e33dce7343$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $bd5028e33dce7343$export$b8f5890fc79d6aca; }, function (v) { return $bd5028e33dce7343$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $bd5028e33dce7343$export$60241385465d0a34; }, function (v) { return $bd5028e33dce7343$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $bd5028e33dce7343$export$306c0aa65ff9ec16; }, function (v) { return $bd5028e33dce7343$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $bd5028e33dce7343$export$7b286972b8d8ccbf; }, function (v) { return $bd5028e33dce7343$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $bd5028e33dce7343$export$83d89fbfd8236492; }, function (v) { return $bd5028e33dce7343$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bd5028e33dce7343$export$9c16c1426311996d;
var $bd5028e33dce7343$export$dca3b0875bd9a954;
var $bd5028e33dce7343$export$16fa2f45be04daa8;
var $bd5028e33dce7343$export$ffb0004e005737fa;
var $bd5028e33dce7343$export$e2c29f18771995cb;
var $bd5028e33dce7343$export$221d75b3f55bb0bd;
var $bd5028e33dce7343$export$5f8d39834fd61797;
var $bd5028e33dce7343$export$74bf444e3cd11ea5;
var $bd5028e33dce7343$export$1ced07cd6b1985ce;
var $bd5028e33dce7343$export$abd8e32b826d7ea7;
var $bd5028e33dce7343$export$69a3209f1a06c04d;
var $bd5028e33dce7343$export$8c538325882c7eec;
var $bd5028e33dce7343$export$e530037191fcd5d7;
var $bd5028e33dce7343$export$fd42f52fd3ae1109;
var $bd5028e33dce7343$export$c8a8987d4410bf2d;
var $bd5028e33dce7343$export$7d1e3a5e95ceca43;
var $bd5028e33dce7343$export$257a8862b851cb5b;
var $bd5028e33dce7343$export$a8257692ac88316c;
var $bd5028e33dce7343$export$488013bae63b21da;
var $bd5028e33dce7343$export$7c73462e0d25e514;
var $bd5028e33dce7343$export$7568632d0d33d16d;
var $bd5028e33dce7343$export$f93f40ac0ca7e3a8;
var $bd5028e33dce7343$export$1f96ae73734a86cc;
var $bd5028e33dce7343$export$9a47ced3238df325;
var $bd5028e33dce7343$export$35808ee640e87ca7;
var $bd5028e33dce7343$export$fae74005e78b1a27;
var $bd5028e33dce7343$export$dc8fbce3eb94dc1e;
var $bd5028e33dce7343$export$6a7bc4e911dc01cf;
var $bd5028e33dce7343$export$6d9c69b0de29b591;
var $bd5028e33dce7343$export$7f54fc3180508a52;
var $bd5028e33dce7343$export$f680877a34711e37;
var $bd5028e33dce7343$export$d5a552a76deda3c2;
var $bd5028e33dce7343$export$aaabe4eda9ed9969;
var $bd5028e33dce7343$export$e5c5a5f917a5871c;
var $bd5028e33dce7343$export$1538c33de8887b59;
var $bd5028e33dce7343$export$fca7f784ae7a249a;
var $bd5028e33dce7343$export$13e3392192263954;
var $bd5028e33dce7343$export$b8f5890fc79d6aca;
var $bd5028e33dce7343$export$60241385465d0a34;
var $bd5028e33dce7343$export$306c0aa65ff9ec16;
var $bd5028e33dce7343$export$7b286972b8d8ccbf;
var $bd5028e33dce7343$export$83d89fbfd8236492;
"use strict";
var $bd5028e33dce7343$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $bd5028e33dce7343$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $bd5028e33dce7343$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $bd5028e33dce7343$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $bd5028e33dce7343$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $bd5028e33dce7343$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $bd5028e33dce7343$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $bd5028e33dce7343$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $bd5028e33dce7343$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $bd5028e33dce7343$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $bd5028e33dce7343$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $bd5028e33dce7343$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $bd5028e33dce7343$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $bd5028e33dce7343$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $bd5028e33dce7343$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$bd5028e33dce7343$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $bd5028e33dce7343$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $bd5028e33dce7343$var$assign = Object.assign, $bd5028e33dce7343$var$emptyObject = {};
function $bd5028e33dce7343$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $bd5028e33dce7343$var$emptyObject;
    this.updater = updater || $bd5028e33dce7343$var$ReactNoopUpdateQueue;
}
$bd5028e33dce7343$var$Component.prototype.isReactComponent = {};
$bd5028e33dce7343$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$bd5028e33dce7343$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $bd5028e33dce7343$var$ComponentDummy() {}
$bd5028e33dce7343$var$ComponentDummy.prototype = $bd5028e33dce7343$var$Component.prototype;
function $bd5028e33dce7343$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $bd5028e33dce7343$var$emptyObject;
    this.updater = updater || $bd5028e33dce7343$var$ReactNoopUpdateQueue;
}
var $bd5028e33dce7343$var$pureComponentPrototype = $bd5028e33dce7343$var$PureComponent.prototype = new $bd5028e33dce7343$var$ComponentDummy();
$bd5028e33dce7343$var$pureComponentPrototype.constructor = $bd5028e33dce7343$var$PureComponent;
$bd5028e33dce7343$var$assign($bd5028e33dce7343$var$pureComponentPrototype, $bd5028e33dce7343$var$Component.prototype);
$bd5028e33dce7343$var$pureComponentPrototype.isPureReactComponent = !0;
var $bd5028e33dce7343$var$isArrayImpl = Array.isArray;
function $bd5028e33dce7343$var$noop() {}
var $bd5028e33dce7343$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $bd5028e33dce7343$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $bd5028e33dce7343$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $bd5028e33dce7343$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $bd5028e33dce7343$var$cloneAndReplaceKey(oldElement, newKey) {
    return $bd5028e33dce7343$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $bd5028e33dce7343$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $bd5028e33dce7343$var$REACT_ELEMENT_TYPE;
}
function $bd5028e33dce7343$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $bd5028e33dce7343$var$userProvidedKeyEscapeRegex = /\/+/g;
function $bd5028e33dce7343$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $bd5028e33dce7343$var$escape("" + element.key) : index.toString(36);
}
function $bd5028e33dce7343$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($bd5028e33dce7343$var$noop, $bd5028e33dce7343$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $bd5028e33dce7343$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $bd5028e33dce7343$var$REACT_ELEMENT_TYPE:
                case $bd5028e33dce7343$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $bd5028e33dce7343$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $bd5028e33dce7343$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $bd5028e33dce7343$var$getElementKey(children, 0) : nameSoFar, $bd5028e33dce7343$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($bd5028e33dce7343$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $bd5028e33dce7343$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($bd5028e33dce7343$var$isValidElement(callback) && (callback = $bd5028e33dce7343$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($bd5028e33dce7343$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($bd5028e33dce7343$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $bd5028e33dce7343$var$getElementKey(nameSoFar, i), invokeCallback += $bd5028e33dce7343$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $bd5028e33dce7343$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $bd5028e33dce7343$var$getElementKey(nameSoFar, i++), invokeCallback += $bd5028e33dce7343$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $bd5028e33dce7343$var$mapIntoArray($bd5028e33dce7343$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $bd5028e33dce7343$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $bd5028e33dce7343$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $bd5028e33dce7343$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $bd5028e33dce7343$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $bd5028e33dce7343$var$Children = {
    map: $bd5028e33dce7343$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $bd5028e33dce7343$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $bd5028e33dce7343$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $bd5028e33dce7343$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$bd5028e33dce7343$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$bd5028e33dce7343$export$9c16c1426311996d = $bd5028e33dce7343$var$REACT_ACTIVITY_TYPE;
$bd5028e33dce7343$export$dca3b0875bd9a954 = $bd5028e33dce7343$var$Children;
$bd5028e33dce7343$export$16fa2f45be04daa8 = $bd5028e33dce7343$var$Component;
$bd5028e33dce7343$export$ffb0004e005737fa = $bd5028e33dce7343$var$REACT_FRAGMENT_TYPE;
$bd5028e33dce7343$export$e2c29f18771995cb = $bd5028e33dce7343$var$REACT_PROFILER_TYPE;
$bd5028e33dce7343$export$221d75b3f55bb0bd = $bd5028e33dce7343$var$PureComponent;
$bd5028e33dce7343$export$5f8d39834fd61797 = $bd5028e33dce7343$var$REACT_STRICT_MODE_TYPE;
$bd5028e33dce7343$export$74bf444e3cd11ea5 = $bd5028e33dce7343$var$REACT_SUSPENSE_TYPE;
$bd5028e33dce7343$export$1ced07cd6b1985ce = $bd5028e33dce7343$var$ReactSharedInternals;
$bd5028e33dce7343$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $bd5028e33dce7343$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$bd5028e33dce7343$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$bd5028e33dce7343$export$8c538325882c7eec = function() {
    return null;
};
$bd5028e33dce7343$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $bd5028e33dce7343$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$bd5028e33dce7343$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $bd5028e33dce7343$var$ReactElement(element.type, key, props);
};
$bd5028e33dce7343$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $bd5028e33dce7343$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $bd5028e33dce7343$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$bd5028e33dce7343$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$bd5028e33dce7343$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $bd5028e33dce7343$var$ReactElement(type, key, props);
};
$bd5028e33dce7343$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$bd5028e33dce7343$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $bd5028e33dce7343$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$bd5028e33dce7343$export$a8257692ac88316c = $bd5028e33dce7343$var$isValidElement;
$bd5028e33dce7343$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $bd5028e33dce7343$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $bd5028e33dce7343$var$lazyInitializer
    };
};
$bd5028e33dce7343$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $bd5028e33dce7343$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$bd5028e33dce7343$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $bd5028e33dce7343$var$ReactSharedInternals.T, currentTransition = {};
    $bd5028e33dce7343$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $bd5028e33dce7343$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($bd5028e33dce7343$var$noop, $bd5028e33dce7343$var$reportGlobalError);
    } catch (error) {
        $bd5028e33dce7343$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $bd5028e33dce7343$var$ReactSharedInternals.T = prevTransition;
    }
};
$bd5028e33dce7343$export$f93f40ac0ca7e3a8 = function() {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useCacheRefresh();
};
$bd5028e33dce7343$export$1f96ae73734a86cc = function(usable) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.use(usable);
};
$bd5028e33dce7343$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$bd5028e33dce7343$export$35808ee640e87ca7 = function(callback, deps) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$bd5028e33dce7343$export$fae74005e78b1a27 = function(Context) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useContext(Context);
};
$bd5028e33dce7343$export$dc8fbce3eb94dc1e = function() {};
$bd5028e33dce7343$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$bd5028e33dce7343$export$6d9c69b0de29b591 = function(create, deps) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useEffect(create, deps);
};
$bd5028e33dce7343$export$7f54fc3180508a52 = function(callback) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$bd5028e33dce7343$export$f680877a34711e37 = function() {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useId();
};
$bd5028e33dce7343$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$bd5028e33dce7343$export$aaabe4eda9ed9969 = function(create, deps) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$bd5028e33dce7343$export$e5c5a5f917a5871c = function(create, deps) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$bd5028e33dce7343$export$1538c33de8887b59 = function(create, deps) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useMemo(create, deps);
};
$bd5028e33dce7343$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$bd5028e33dce7343$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$bd5028e33dce7343$export$b8f5890fc79d6aca = function(initialValue) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useRef(initialValue);
};
$bd5028e33dce7343$export$60241385465d0a34 = function(initialState) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useState(initialState);
};
$bd5028e33dce7343$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$bd5028e33dce7343$export$7b286972b8d8ccbf = function() {
    return $bd5028e33dce7343$var$ReactSharedInternals.H.useTransition();
};
$bd5028e33dce7343$export$83d89fbfd8236492 = "19.2.8";

});



parcelRegister("dROUv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $daeNZ = parcelRequire("daeNZ");
const { memo: $4e082f0934fdc0e9$var$memo, useCallback: $4e082f0934fdc0e9$var$useCallback } = window.React;
function $4e082f0934fdc0e9$var$GridItem({ post: post, gridItemClasses: gridItemClasses = "" }) {
    const { stateMap: stateMap, setItem: setItem, toggle: toggle, deleteItem: deleteItem } = (0, $daeNZ.useTransition)();
    const { status: status } = stateMap.get(post?.ID) || {
        status: "preEnter"
    };
    const classNames = [
        gridItemClasses,
        "resource-hub-grid-item card-appear",
        status
    ].filter(Boolean).join(" ");
    const itemCallbackRef = $4e082f0934fdc0e9$var$useCallback((node)=>{
        if (node) {
            setItem(post?.ID);
            toggle(post?.ID, true);
            return;
        }
        deleteItem(post?.ID);
    }, [
        deleteItem,
        setItem,
        post?.ID,
        toggle
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: classNames,
        id: `post-id-${post?.ID}`,
        ref: itemCallbackRef
    }, /*#__PURE__*/ React.createElement("a", {
        className: "card add-hover-scale-up h-100 bg-light-subtle border rounded-3 text-decoration-none link-reset",
        href: post?.permalink,
        style: {
            overflow: "clip"
        }
    }, post?.hub_img_markup ? /*#__PURE__*/ React.createElement("div", {
        dangerouslySetInnerHTML: {
            __html: post.hub_img_markup
        }
    }) : /*#__PURE__*/ React.createElement("div", {
        dangerouslySetInnerHTML: {
            __html: post?.featured_image_markup
        }
    }), /*#__PURE__*/ React.createElement("div", {
        className: "card-body d-flex flex-column p-3 justify-content-between align-items-start flex-grow-1"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex-grow-1"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mt-3 mb-2 "
    }, /*#__PURE__*/ React.createElement("span", {
        className: "text-uppercase font-weight-bold"
    }), post?.sponsor_name && /*#__PURE__*/ React.createElement("div", {
        className: "text-small mt-n1"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "text-gray"
    }, "Presented by "), " ", post?.sponsor_name)), /*#__PURE__*/ React.createElement("h2", {
        className: "h3 text-left font-heading"
    }, post?.post_meta?.hub_alt_title?.[0].length && post?.post_meta?.hub_alt_title?.[0] || post?.post_title)), /*#__PURE__*/ React.createElement("a", {
        href: post?.permalink,
        className: "btn btn-outline-primary mt-3 text-small fw-bold custom-rc-button"
    }, "View"))));
}
var $4e082f0934fdc0e9$var$_default = module.exports.default = $4e082f0934fdc0e9$var$memo($4e082f0934fdc0e9$var$GridItem);

});
parcelRegister("daeNZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TransitionProvider = $6f4ef03c8a01e0dc$var$TransitionProvider;
module.exports.useTransition = $6f4ef03c8a01e0dc$var$useTransition;
const { createContext: $6f4ef03c8a01e0dc$var$createContext, useContext: $6f4ef03c8a01e0dc$var$useContext } = window.React;
const $6f4ef03c8a01e0dc$var$TransitionContext = $6f4ef03c8a01e0dc$var$createContext(null);
function $6f4ef03c8a01e0dc$var$TransitionProvider({ value: value, children: children }) {
    return /*#__PURE__*/ React.createElement($6f4ef03c8a01e0dc$var$TransitionContext.Provider, {
        value: value
    }, children);
}
function $6f4ef03c8a01e0dc$var$useTransition() {
    const context = $6f4ef03c8a01e0dc$var$useContext($6f4ef03c8a01e0dc$var$TransitionContext);
    if (!context) throw new Error("useTransition must be used within a TransitionProvider");
    return context;
}

});


parcelRegister("97xNZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6a9f7d997733476b$var$PlaceholderGridItem;
function $6a9f7d997733476b$var$_extends() {
    return $6a9f7d997733476b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6a9f7d997733476b$var$_extends.apply(null, arguments);
}
function $6a9f7d997733476b$var$PlaceholderGridItem({ columnClassesForGrid: columnClassesForGrid = "", ...props }) {
    const className = [
        "card w-100 mb-0 bg-light-subtle shadow-sm text-decoration-none placeholder-glow border-0 p-0 rounded",
        columnClassesForGrid
    ].filter(Boolean).join(" ");
    return /*#__PURE__*/ React.createElement("div", $6a9f7d997733476b$var$_extends({
        className: className,
        style: {
            width: "18rem"
        }
    }, props), /*#__PURE__*/ React.createElement("div", {
        className: "placeholder card-img-top",
        style: {
            height: "280px"
        }
    }), /*#__PURE__*/ React.createElement("div", {
        className: "placeholder-glow card-body"
    }, /*#__PURE__*/ React.createElement("h5", {
        className: "card-title"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "placeholder rounded",
        style: {
            width: "50%",
            height: "2rem"
        }
    })), /*#__PURE__*/ React.createElement("p", {
        className: "card-text"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "placeholder rounded",
        style: {
            width: "80%",
            height: "2.5rem"
        }
    }))));
}

});


parcelRegister("f3F2v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e919a566255c697e$var$Modal;
function $e919a566255c697e$var$_extends() {
    return $e919a566255c697e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e919a566255c697e$var$_extends.apply(null, arguments);
}
const { useCallback: $e919a566255c697e$var$useCallback } = window.React;
function $e919a566255c697e$var$Modal({ children: children, isModalOpen: isModalOpen, className: className = "", onClose: onClose, ...props }) {
    const dialogCallbackRef = $e919a566255c697e$var$useCallback((node)=>{
        const dialog = node;
        if (!dialog) return;
        if (isModalOpen && !dialog.open) {
            dialog.showModal();
            dialog.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        } else if (!isModalOpen && dialog.open) dialog.close();
    }, [
        isModalOpen
    ]);
    const handleBackdropClick = $e919a566255c697e$var$useCallback((e)=>{
        const dialog = e.target.closest("dialog");
        if (!dialog) return;
        dialog.close();
    }, [
        onClose
    ]);
    return /*#__PURE__*/ React.createElement("dialog", $e919a566255c697e$var$_extends({
        ref: dialogCallbackRef,
        className: className,
        onClick: handleBackdropClick,
        onClose: onClose
    }, props), children);
}

});

parcelRegister("b6hmR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $eef6a47239a53852$var$Sidebar;

var $hrne4 = parcelRequire("hrne4");

var $jURgU = parcelRequire("jURgU");

var $eef6a47239a53852$var$_Toggle = $eef6a47239a53852$var$_interopRequireDefault((parcelRequire("hxMO9")));
function $eef6a47239a53852$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $eef6a47239a53852$var$Sidebar({ className: className = "" }) {
    const { categoriesFiltered: categoriesFiltered, resourceTypesFiltered: resourceTypesFiltered, handleToggle: handleToggle, resetFilters: resetFilters, isBusy: isBusy } = (0, $jURgU.useAppContext)();
    return /*#__PURE__*/ React.createElement("div", {
        className: className,
        onClick: $eef6a47239a53852$var$scrollToGridSection
    }, adw_resource_center?.sidebar_resource_types?.length > 0 && /*#__PURE__*/ React.createElement("div", {
        className: "fw-bold mb-3 text-uppercase"
    }, "Type"), adw_resource_center?.sidebar_resource_types?.map((cat, i)=>/*#__PURE__*/ React.createElement($eef6a47239a53852$var$_Toggle.default, {
            key: i,
            id: cat?.term_id,
            labelName: (0, $hrne4.decodeEntities)(cat?.name),
            cb: ({ id: id })=>handleToggle({
                    id: id,
                    taxonomy: "resource_type"
                }),
            inputState: resourceTypesFiltered?.includes?.(cat?.term_id)
        })), adw_resource_center?.sidebar_categories?.length > 0 && /*#__PURE__*/ React.createElement("div", {
        className: "fw-bold mb-3 mt-4 pt-2 text-uppercase"
    }, "Category"), adw_resource_center?.sidebar_categories?.map((cat, i)=>/*#__PURE__*/ React.createElement($eef6a47239a53852$var$_Toggle.default, {
            key: i,
            id: cat?.term_id,
            labelName: (0, $hrne4.decodeEntities)(cat?.name),
            cb: ({ id: id })=>handleToggle({
                    id: id,
                    taxonomy: "category"
                }),
            inputState: categoriesFiltered?.includes?.(cat?.term_id)
        })), /*#__PURE__*/ React.createElement("div", {
        className: "d-flex justify-content-xl-start justify-content-center"
    }, /*#__PURE__*/ React.createElement("a", {
        href: "#",
        role: "button",
        disabled: isBusy,
        className: "mt-3 py-2 px-2 d-inline-flex bg-white align-items-center fw-bold text-small btn-outline-secondary text-dark btn-sm shadow-sm rounded-pill",
        onClick: resetFilters
    }, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        fill: "currentColor",
        className: "ml-1 bi bi-arrow-clockwise",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"
    })), /*#__PURE__*/ React.createElement("span", {
        className: "mx-2 text-small"
    }, "Reset"))));
}
function $eef6a47239a53852$var$scrollToGridSection(e) {
    e.stopPropagation();
    $("html, body").animate({
        scrollTop: $(".filterable-grid-for-hub").offset().top - 100
    }, 500, "linear");
}

});
parcelRegister("hrne4", function(module, exports) {

$parcel$export(module.exports, "decodeEntities", function () { return $dda22c0315f072ca$export$6cb344a21ca18aec; });
// packages/html-entities/src/index.ts
var $dda22c0315f072ca$var$_decodeTextArea;
function $dda22c0315f072ca$export$6cb344a21ca18aec(html) {
    if ("string" !== typeof html || -1 === html.indexOf("&")) return html;
    if (void 0 === $dda22c0315f072ca$var$_decodeTextArea) {
        if (document.implementation && document.implementation.createHTMLDocument) $dda22c0315f072ca$var$_decodeTextArea = document.implementation.createHTMLDocument("").createElement("textarea");
        else $dda22c0315f072ca$var$_decodeTextArea = document.createElement("textarea");
    }
    $dda22c0315f072ca$var$_decodeTextArea.innerHTML = html;
    const decoded = $dda22c0315f072ca$var$_decodeTextArea.textContent ?? "";
    $dda22c0315f072ca$var$_decodeTextArea.innerHTML = "";
    return decoded;
}

});

parcelRegister("hxMO9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b165b827ca53254c$var$Toggle;
const { useCallback: $b165b827ca53254c$var$useCallback } = window.React;
function $b165b827ca53254c$var$Toggle({ labelName: labelName, inputState: inputState, cb: cb, id: id }) {
    const handleToggle = $b165b827ca53254c$var$useCallback(()=>cb({
            id: id
        }), [
        cb,
        id
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: "row mb-3 d-flex align-items-center"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "col-auto px-3"
    }, /*#__PURE__*/ React.createElement("input", {
        id: id,
        onClick: handleToggle,
        type: "button",
        className: inputState ? `d-none tgl tgl-light control control-length mixitup-control-active` : "d-none tgl tgl-light control control-length "
    }), /*#__PURE__*/ React.createElement("label", {
        className: "tgl-btn mb-0",
        htmlFor: id
    })), /*#__PURE__*/ React.createElement("div", {
        className: "col"
    }, /*#__PURE__*/ React.createElement("label", {
        className: "tgl-btn mb-0",
        style: {
            cursor: "pointer"
        },
        htmlFor: id
    }, /*#__PURE__*/ React.createElement("p", {
        className: "title mb-0 font-weight-bold text-small font-primary",
        style: {
            cursor: "pointer"
        }
    }, labelName))));
}

});



var $5d2ba46bd2b0a55f$exports = {};
"use strict";
Object.defineProperty($5d2ba46bd2b0a55f$exports, "__esModule", {
    value: true
});
var $1c0810f3846b42de$exports = {};
"use strict";

var $1c0810f3846b42de$var$_App = $1c0810f3846b42de$var$_interopRequireDefault((parcelRequire("h3qcY")));
function $1c0810f3846b42de$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1c0810f3846b42de$var$React = window.React;
const $1c0810f3846b42de$var$ReactDOM = window.ReactDOM;
const $1c0810f3846b42de$var$elGridApp = document.querySelector('.filterable-grid-for-hub');
if ($1c0810f3846b42de$var$elGridApp) {
    const root = $1c0810f3846b42de$var$ReactDOM.client.createRoot($1c0810f3846b42de$var$elGridApp);
    root.render(/*#__PURE__*/ $1c0810f3846b42de$var$React.createElement($1c0810f3846b42de$var$_App.default, null));
}


Object.keys($1c0810f3846b42de$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $5d2ba46bd2b0a55f$exports && $5d2ba46bd2b0a55f$exports[key] === $1c0810f3846b42de$exports[key]) return;
    Object.defineProperty($5d2ba46bd2b0a55f$exports, key, {
        enumerable: true,
        get: function() {
            return $1c0810f3846b42de$exports[key];
        }
    });
});

})();
//# sourceMappingURL=app.js.map
